import { Controller } from "stimulus"
import { DirectUpload } from "@rails/activestorage"
import installBlogImages, {installPageImages} from '../src/javascripts/blog_images';
import startpageSettings from "../src/javascripts/startpage_settings"
import cartSettings from '../src/javascripts/cart_settings';
import installUserAccountImage from '../src/javascripts/user_account_image';

class SettingsController extends Controller {

  static targets = [ "company_label", "vatid_label", "smtp_port", "webshop_company", "webshop_name", "webshop_description", "webshop_countries", "webshop_languages", "webshop_currencies", "webshop_payment_gateways", "webshop_payment_methods", "webshop_template", "webshop_tabs_languages", "webshop_version",  "webshop_tab_content_languages", "webshop_locales", "webshop_shipping_settings", "webshop_editable_settings", "startpage_sections", "webshop_tabs_startpage_countries", "webshop_tab_content_startpage_countries", "webshop_categories", "webshop_subcategories", "categories", "webshop_pages", "blogs", "webshop_blogs", "vouchers", "webshop_vouchers", "emailTemplateContent", "cm_bexio_pt_matching", "expiration_date_notification_unit" ]

  static values = {
    directUrl: String,
    blobUrlTemplate: String
  }

  initialize() {
    if(this.element.getAttribute("data-locale")) {
      this.locale = this.element.getAttribute("data-locale");
    }
    if(this.element.getAttribute("data-section")) {
      this.section = this.element.getAttribute("data-section");
    }
    if(this.element.getAttribute("data-module")) {
      this.module = this.element.getAttribute("data-module");
    }
    if(this.element.getAttribute("data-reference")) {
      this.reference = this.element.getAttribute("data-reference");
    }
    if(this.element.getAttribute("data-uuid")) {
      this.uuid = this.element.getAttribute("data-uuid");
    }
    if(this.element.getAttribute("data-plugin")) {
      this.plugin = this.element.getAttribute("data-plugin");
    }
  }

  connect() {
    $("#subscription_country").selectpicker({ width: '100%' });
    $("#subscription_locale").selectpicker({ width: '100%' });
    $("#subscription_locale_docs").selectpicker({ width: '100%' });
    $("#store_warehouse").selectpicker({ width: '100%' });
    $("#documents_font").selectpicker({ width: '100%' });
    $("#advanced_smtp_encryption").selectpicker({ width: '100%' });
    $(".selectpicker.currencies").selectpicker({ width: '100%' });
    $(".selectpicker.vat-countries").selectpicker({ width: '100%' });
    $(".selectpicker.document-locale").selectpicker({ width: '200px' });
    $("#orders_customers").selectpicker({ width: '100%' });
    $("#purchases_suppliers").selectpicker({ width: '100%' });
    $("#orders_payment_methods").selectpicker({ width: '100%' });

    if(this.section == 'documents') {
      ['columns_selection_sheets', 'columns_cancellation_invoices', 'columns_credit_notes', 'columns_payment_reminders'].forEach((id) => {
        const list = document.getElementById(id);
        if (list) new Sortable(list, { handle: '.handle', animation: 150 });
      });
      new Sortable(columns_offers, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_order_confirmations, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_invoices, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_receipts, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_delivery_notes, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_pick_lists, {
          handle: '.handle',
          animation: 150
      });
      new Sortable(columns_purchase_orders, {
          handle: '.handle',
          animation: 150
      });
    }

    if(this.section == 'items') {
      this.loadItemStates();
      this.loadItemPriceCategories();
    }

    if(this.section == 'webshop') {
      this.loadShopConfiguration(this.uuid);
      this.loadShopPages(this.uuid);
      this.loadShopBlogs(this.uuid);
      this.loadShopVouchers(this.uuid);
      this.shopInitCategorySelectDialog();
      this.shopInitItemSelectDialog();

      new Sortable(this.webshop_categoriesTarget, {
          handle: 'div.category',
          animation: 150,
      });

      this.webshop_subcategoriesTargets.forEach((div, i) => {
        new Sortable(div, {
            handle: '.handle',
            animation: 150,
        });
      });

      let sel = document.querySelector("#webshop_images_format");
      if(sel) {
        sel.value = sel.dataset.selected;
      }

      // Setup Trix upload handler only for blogs
      this.setupBlogTrixUploadHandler();
    }

    if(this.section == 'email') {
      let chk = document.querySelector("input#email_smtp_enabled");
      if(chk) {
        let div = chk.closest("div.tab-pane");
        let table = div.querySelector('table');

        if(chk.checked) {
          table.querySelectorAll('input, select, button').forEach((inp, i) => {
            inp.removeAttribute('disabled')
          });
        } else {
          table.querySelectorAll('input, select, button').forEach((inp, i) => {
            inp.setAttribute('disabled', 'true')
          });
        }
      }
    }

    if(this.section == 'warehouses') {
      if(this.hasExpiration_date_notification_unitTarget) {
        this.expiration_date_notification_unitTarget.value = this.expiration_date_notification_unitTarget.dataset.selected;
      }
    }

    if(this.reference) {
      this.completeBankaccountLink();
    }

    if(this.plugin) {
      if(this.plugin == 'dhlexpress_mydhl') {
        let sel = document.querySelector("#settings_pickup_country");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        $("#settings_pickup_country").selectpicker({ width: '100%' });
      } else if(this.plugin == 'swisspost_digital_commerce') {
        let sel = document.querySelector("#settings_sender_country");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        $("#settings_sender_country").selectpicker({ width: '100%' });
      }
    }

    if(this.module) {
      if(this.module == 'bexio') {
        let sel = document.querySelector("#settings_user_contacts");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        sel = document.querySelector("#settings_user_documents");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        sel = document.querySelector("#settings_bank_account");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        sel = document.querySelector("#settings_transport_account_id");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        sel = document.querySelector("#settings_transport_taxaccount_id");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
        this.cm_bexio_pt_matchingTarget.querySelectorAll('select').forEach((sel, i) => {
          sel.value = sel.dataset.selected;
        });

      }
    }

    if(this.module) {
      if(this.module == 'hci_solutions') {
        let sel = document.querySelector("#hci_solutions_swissmedic_supply_category");
        if(sel) {
          sel.value = sel.dataset.selected;
        }
      }
    }

    $('[data-bs-toggle="popover"]').popover();
    $('[data-bs-toggle="tooltip"]').tooltip();

    $('#loading').fadeOut(200);
  }

  toggleRetention() {
    $("#company_retention_percentage").attr('disabled', !event.target.checked);
    $("#company_retention_percentage").attr('required', event.target.checked);
  }

  toggleAssignCustomerNumber() {
    $("#contacts_customer_number_start").attr('readonly', !event.target.checked);
  }

  toggleCompanyType() {
    let c = document.querySelector("#subscription_country").value;
    if(event.target.value == 'juridical') {
      this.company_labelTarget.textContent = I18n.t('contact.company');

      if(c == 'ES') {
        this.vatid_labelTarget.textContent = 'CIF';
      }
    } else {
      this.company_labelTarget.textContent = I18n.t('contact.name');

      if(c == 'ES') {
        this.vatid_labelTarget.textContent = 'NIF';
      }
    }
  }

  deleteConfirmStore() {
    let that = this;
    var uuid = event.target.dataset.uuid;
    var msg = `<span class="lead">${event.target.dataset.name}</span>`;
    bootbox.dialog({
      message: `${I18n.t('store.confirm.delete')}<br><br>${msg}`,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/store/${uuid}`,
              type: "delete",
              data: "",
              success: function(data) {},
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  deleteConfirmWarehouse() {
    let that = this;
    var uuid = event.target.dataset.uuid;
    var msg = `<span class="lead">${event.target.dataset.name}</span>`;
    bootbox.dialog({
      message: `${I18n.t('warehouse.confirm.delete')}<br><br>${msg}`,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/warehouse/${uuid}`,
              type: "delete",
              data: "",
              success: function(data) {},
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  deleteConfirmBankaccount() {
    let that = this;
    var uuid = event.target.dataset.uuid;
    let name = event.target.dataset.name;
    let iban = event.target.dataset.iban;
    bootbox.dialog({
      message: `${I18n.t('accounting.bankaccount.confirm.delete')}<br><br><span class="lead">${name}</span><br><span class="small text-muted">${iban}</span>`,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/bankaccount/${uuid}/delete`,
              type: "delete",
              data: "",
              success: function(data) {},
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  changeSmtpEncryption() {
    switch(event.target.value) {
      case 'starttls':
        this.smtp_portTarget.value = 587;
        break;
      case 'ssl':
        this.smtp_portTarget.value = 465;
        break;
      default:
        this.smtp_portTarget.value = 25;
    }
  }

  testSmtpServer() {
    let that = this;
    var title = event.target.dataset.title;
    var message = event.target.dataset.message;

    var success = event.target.dataset.success;
    var error = event.target.dataset.error;

    bootbox.prompt({
      title: title,
      message: message,
      locale: that.locale,
      inputType: 'email',
      callback: function(address){
        if(address != '') {
          var form = document.querySelector("#formEmailSmtp");
          var formData = $(form).serialize();
          formData += `&recipient=${address}`
          Rails.ajax({
            url: `/${that.locale}/subscription/smtp_test`,
            type: "post",
            data: formData,
            success: function(data) {
              bootbox.alert(success);
            },
            error: function(data) {
              bootbox.alert(`${error}<br><br><b>${data}</b>`);
            }
          });
        }
      }
  });
  }

  disableButton() {
    event.target.classList.add('disabled');
    let i = event.target.querySelector('i');
    i.classList.add('fa-pulse');
  }

  loadItemStates() {
    Rails.ajax({
      url: `/${this.locale}/subscription/items/states`,
      type: "get",
      success: function(data) {}
    });
  }

  editItemStatus() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <form class="row g-3 align-items-center w-100" action="/${this.locale}/subscription/items/states" accept-charset="UTF-8" data-remote="true" method="post">
        <input required="required" type="hidden" name="status[uuid]" id="status_uuid" value="${event.target.dataset.uuid}">
        <div class="col-auto">
          <input class="form-control flex-fill" required="required" type="text" name="status[name]" id="status_name" value="${event.target.dataset.name}">
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-outline-success btn-sm ms-2"><i class="fas fa-check"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemStates"><i class="fas fa-times"></i></button>
        </div>
      </form>
    `;
  }

  deleteItemStatusConfirm() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <span class="flex-fill">${event.target.dataset.name}</span>
      <button type="button" class="btn btn-danger btn-sm" data-action="click->settings#deleteItemStatus" data-uuid="${event.target.dataset.uuid}">${event.target.dataset.label}</button>
      <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemStates"><i class="fas fa-times"></i></button>
    `;
  }

  deleteItemStatus() {
    let that = this;
    let uuid = event.target.dataset.uuid;
    Rails.ajax({
      url: `/${this.locale}/subscription/items/states/${uuid}`,
      type: "delete",
      success: function(data) {
        that.loadItemStates();
      }
    });
  }


  loadItemPriceCategories() {
    Rails.ajax({
      url: `/${this.locale}/subscription/items/prices`,
      type: "get",
      success: function(data) {}
    });
  }

  loadItemCustomFields() {
    Rails.ajax({
      url: `/${this.locale}/subscription/items/custom_fields`,
      type: "get",
      success: function(data) {}
    });
  }

  loadContactCustomFields() {
    Rails.ajax({
      url: `/${this.locale}/subscription/contacts/custom_fields`,
      type: "get",
      success: function(data) {}
    });
  }

  editItemPriceCategory() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <form class="row g-3 align-items-center w-100" action="/${this.locale}/subscription/items/prices" accept-charset="UTF-8" data-remote="true" method="post">
        <input required="required" type="hidden" name="price_category[uuid]" id="price_category_uuid" value="${event.target.dataset.uuid}">
        <div class="col-auto">
          <input class="form-control flex-fill" required="required" type="text" name="price_category[name]" id="price_category_name" value="${event.target.dataset.name}">
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-outline-success btn-sm ms-2"><i class="fas fa-check"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemPriceCategories"><i class="fas fa-times"></i></button>
        </div>
      </form>
    `;
  }

  editItemCustomField() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <form class="row g-3 align-items-center w-100" action="/${this.locale}/subscription/items/custom_fields" accept-charset="UTF-8" data-remote="true" method="post">
        <input required="required" type="hidden" name="item_custom_field[uuid]" id="item_custom_field_uuid" value="${event.target.dataset.uuid}">
        <div class="col-auto">
          <input class="form-control flex-fill" required="required" type="text" name="item_custom_field[label]" id="item_custom_field_label" value="${event.target.dataset.label}">
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-outline-success btn-sm ms-2"><i class="fas fa-check"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemCustomFields"><i class="fas fa-times"></i></button>
        </div>
      </form>
    `;
  }

  editContactCustomField() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <form class="row g-3 align-items-center w-100" action="/${this.locale}/subscription/contacts/custom_fields" accept-charset="UTF-8" data-remote="true" method="post">
        <input required="required" type="hidden" name="contact_custom_field[uuid]" id="contact_custom_field_uuid" value="${event.target.dataset.uuid}">
        <div class="col-auto">
          <input class="form-control flex-fill" required="required" type="text" name="contact_custom_field[label]" id="contact_custom_field_label" value="${event.target.dataset.label}">
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-outline-success btn-sm ms-2"><i class="fas fa-check"></i></button>
          <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadContactCustomFields"><i class="fas fa-times"></i></button>
        </div>
      </form>
    `;
  }

  deleteItemPriceCategoryConfirm() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <span class="flex-fill">${event.target.dataset.name}</span>
      <button type="button" class="btn btn-danger btn-sm" data-action="click->settings#deleteItemPriceCategory" data-uuid="${event.target.dataset.uuid}">${event.target.dataset.label}</button>
      <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemPriceCategories"><i class="fas fa-times"></i></button>
    `;
  }

  deleteItemCustomFieldConfirm() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <span class="flex-fill">${event.target.dataset.name}</span>
      <button type="button" class="btn btn-danger btn-sm" data-action="click->settings#deleteItemCustomField" data-uuid="${event.target.dataset.uuid}">${event.target.dataset.label}</button>
      <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadItemCustomFields"><i class="fas fa-times"></i></button>
    `;
  }

  deleteContactCustomFieldConfirm() {
    let parent = event.target.parentNode;
    parent.innerHTML = `
      <span class="flex-fill">${event.target.dataset.name}</span>
      <button type="button" class="btn btn-danger btn-sm" data-action="click->settings#deleteContactCustomField" data-uuid="${event.target.dataset.uuid}">${event.target.dataset.label}</button>
      <button type="button" class="btn btn-outline-secondary btn-sm ms-2" data-action="click->settings#loadContactCustomFields"><i class="fas fa-times"></i></button>
    `;
  }

  deleteItemPriceCategory() {
    let that = this;
    let uuid = event.target.dataset.uuid;
    Rails.ajax({
      url: `/${this.locale}/subscription/items/prices/${uuid}`,
      type: "delete",
      success: function(data) {
        that.loadItemPriceCategories();
      }
    });
  }

  deleteItemCustomField() {
    let that = this;
    let uuid = event.target.dataset.uuid;
    Rails.ajax({
      url: `/${this.locale}/subscription/items/custom_field/${uuid}`,
      type: "delete",
      success: function(data) {
        that.loadItemCustomFields();
      }
    });
  }

  deleteContactCustomField() {
    let that = this;
    let uuid = event.target.dataset.uuid;
    Rails.ajax({
      url: `/${this.locale}/subscription/contacts/custom_field/${uuid}`,
      type: "delete",
      success: function(data) {
        that.loadContactCustomFields();
      }
    });
  }

  completeBankaccountLink() {
    Rails.ajax({
      url: `/${this.locale}/bankaccount/${this.reference}/link/complete`,
      type: "get",
      success: function(data) {}
    });
  }

  addAPIUser() {
    var that = this;
    let table = document.querySelector('table');
    let rows = table.rows.length;
    bootbox.prompt({
      title: I18n.t('api.new'),
      locale: that.locale,
      inputType: 'text',
      value: `API #${rows+1}`,
      callback: function(comment){
        if(comment) {
          Rails.ajax({
            url: `/${that.locale}/subscription/api/create`,
            type: "post",
            data: `comment=${comment}`,
            success: function(data) {
              location.reload()
            },
            error: function(data) {}
          });
        }
      }
    });
  }

  deleteAPIUser() {
    let td = event.target.parentNode;
    let btnDelete = td.querySelector('.btn.btn-danger');
    event.target.classList.add('d-none');
    btnDelete.classList.remove('d-none');
  }

  deleteFeed() {
    let td = event.target.parentNode;
    let btnDelete = td.querySelector('.btn.btn-danger');
    event.target.classList.add('d-none');
    btnDelete.classList.remove('d-none');
  }

  showAPISecret() {
    let td = event.target.parentNode.parentNode;
    td.querySelectorAll('span').forEach((span, i) => {
      span.classList.toggle('d-none');
    });
  }

  copyAPISecret() {
    let secret = event.target.dataset.secret;
    if(secret) {
      navigator.clipboard.writeText(secret);
      business.showToast(I18n.t('api.credentials_copied'));
    }
    event.target.blur();
  }

  messagingEmailToggleOwnServer() {
    let div = event.target.closest("div.tab-pane");
    let table = div.querySelector('table');

    if(event.target.checked) {
      table.querySelectorAll('input, select, button').forEach((inp, i) => {
        inp.removeAttribute('disabled')
      });
    } else {
      table.querySelectorAll('input, select, button').forEach((inp, i) => {
        inp.setAttribute('disabled', 'true')
      });
    }
  }

  changeEmailTemplateLanguage() {
    var element = document.querySelector("trix-editor")
    element.editor.loadHTML('');

    let div = event.target.closest("div.container-fluid");
    let template = div.querySelector("select#email_template");
    template.value = '';
  }

  loadEmailTemplate() {
    let div = event.target.closest("div.container-fluid");
    let language = div.querySelector("select#email_template_language").value;
    let template = div.querySelector("select#email_template").value;
    var element = document.querySelector("trix-editor")
    element.editor.loadHTML('');

    let content = div.querySelector('input[name="email[template]"]');
    content.value = '';

    if(template != '') {
      Rails.ajax({
        url: `/${this.locale}/settings/config?attr=messaging.templates.${language}.${template}`,
        type: "get",
        data: "",
        success: function(data) {
          element.editor.loadHTML(data);
        },
        error: function(data) {}
      });
    }
  }

  saveEmailTemplate() {
    let div = event.target.closest("div.container-fluid");
    let language = div.querySelector("select#email_template_language").value;
    let template = div.querySelector("select#email_template").value;
    let content = div.querySelector('input[name="email[template]"]');

    var fd = new FormData();
    fd.append("attr", `messaging.templates.${language}.${template}`);
    fd.append("value", content.value);

    Rails.ajax({
      url: `/${this.locale}/settings/config`,
      type: "post",
      data: fd,
      success: function(data) {
        business.showAlert('success', I18n.t('subscription.message.settings_saved'));
      },
      error: function(data) {}
    });
  }

  loadShopConfiguration(uuid) {
    var that = this;

    Rails.ajax({
      url: `/${this.locale}/webshop/${uuid}/config`,
      type: "get",
      success: function(data) {
        that.populateCartAppearance(data);

        that.webshop_versionTarget.textContent = data.system.version;
        that.webshop_companyTarget.textContent = data.system.company;
        that.webshop_nameTarget.textContent = data.system.name;
        that.webshop_descriptionTarget.textContent = data.system.description;
        that.webshop_countriesTarget.innerHTML = `<b>${countries.getName(data.system.country, that.locale)}</b>`
        that.webshop_tabs_startpage_countriesTarget.innerHTML = `
          <button class="nav-item nav-link active" type="button" data-bs-target="#startpage_country_${data.system.country}" role="tab" data-bs-toggle="tab">
            ${countries.getName(data.system.country, that.locale)}
          </button>
        `
        that.webshop_tab_content_startpage_countriesTarget.innerHTML = `
          <div role="tabpanel" class="tab-pane active pt-4 pl-2 pr-2" id="startpage_country_${data.system.country}" data-country="${data.system.country}">
          </div>
        `

        for(let i = 0; i < data.system.countries.length; i++) {
          if(data.system.countries[i] == data.system.country) {
            continue;
          }
          that.webshop_countriesTarget.innerHTML += `<br>${countries.getName(data.system.countries[i], that.locale)}`

          that.webshop_tabs_startpage_countriesTarget.innerHTML += `
            <button class="nav-item nav-link" type="button" data-bs-target="#startpage_country_${data.system.countries[i]}" role="tab" data-bs-toggle="tab">
              ${countries.getName(data.system.countries[i], that.locale)}
            </button>
          `
          that.webshop_tab_content_startpage_countriesTarget.innerHTML += `
            <div role="tabpanel" class="tab-pane pt-4 pl-2 pr-2" id="startpage_country_${data.system.countries[i]}" data-country="${data.system.countries[i]}"></div>
          `
        }

        that.webshop_languagesTarget.innerHTML = `<b>${I18n.t(`language.${data.system.locale}`)}</b>`;

        const activeLanguagePane = that.webshop_tab_content_languagesTarget.querySelector('.tab-pane.active');
        const activeLanguage = activeLanguagePane ? activeLanguagePane.id.replace('language_', '') :
          (data.system.locales.includes(that.locale) ? that.locale : data.system.locale);

        that.webshop_tabs_languagesTarget.innerHTML = `
          <button class="nav-item nav-link active" type="button" data-bs-target="#language_${data.system.locale}" role="tab" data-bs-toggle="tab">
            ${I18n.t(`language.${data.system.locale}`)}
          </button>
        `
        that.webshop_tab_content_languagesTarget.innerHTML = `
          <div role="tabpanel" class="tab-pane active pt-2 pl-2 pr-2" id="language_${data.system.locale}">
            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <div class="form-group mb-3 ms-2">
                  <label for="start_header_${data.system.locale}">
                    ${I18n.t('webshop.settings.startpage_header')}
                    | ${I18n.t(`language.${data.system.locale}`)}
                  </label>
                  <input class="form-control" type="text" name="start[header_${data.system.locale}]" id="start_header_${data.system.locale}">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-9">
                <div class="form-group mb-3 ms-2">
                  <label for="trix_startpage_description_${data.system.locale}">
                    ${I18n.t('webshop.settings.startpage_description')}
                    | ${I18n.t(`language.${data.system.locale}`)}
                  </label>
                  <input type="hidden" name="start[description_${data.system.locale}]" id="start_description_${data.system.locale}">
                  <div class="trix-content">
                    <trix-editor id="trix_startpage_description_${data.system.locale}" class="description" input="start_description_${data.system.locale}" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                    </trix-editor>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-9">
                <div class="form-group mb-3 ms-2">
                  <label for="trix_startpage_footer_${data.system.locale}">
                    ${I18n.t('webshop.settings.startpage_footer')}
                    | ${I18n.t(`language.${data.system.locale}`)}
                  </label>
                  <input type="hidden" name="start[footer_${data.system.locale}]" id="start_footer_${data.system.locale}">
                  <div class="trix-content">
                    <trix-editor id="trix_startpage_footer_${data.system.locale}" class="" input="start_footer_${data.system.locale}" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                    </trix-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `

        that.locales = data.system.locales;
        that.country = data.system.country;
        that.countries = data.system.countries;
        that.webshop_localesTarget.value = data.system.locales;

        for(let i = 0; i < data.system.locales.length; i++) {
          if(data.system.locales[i] == data.system.locale) {
            continue;
          }

          that.webshop_languagesTarget.innerHTML += `<br>${I18n.t(`language.${data.system.locales[i]}`)}`

          that.webshop_tabs_languagesTarget.insertAdjacentHTML('beforeend', `
            <button class="nav-item nav-link" type="button" data-bs-target="#language_${data.system.locales[i]}" role="tab" data-bs-toggle="tab">
              ${I18n.t(`language.${data.system.locales[i]}`)}
            </button>
          `);

          that.webshop_tab_content_languagesTarget.insertAdjacentHTML('beforeend', `
            <div role="tabpanel" class="tab-pane pt-2 pl-2 pr-2" id="language_${data.system.locales[i]}">
              <div class="row mt-4">
                <div class="col-12 col-md-6">
                  <div class="form-group mb-3 ms-2">
                    <label for="start_header_${data.system.locales[i]}">
                      ${I18n.t('webshop.settings.startpage_header')}
                      | ${I18n.t(`language.${data.system.locales[i]}`)}
                    </label>
                    <input class="form-control" data-settings-target="webshop_startpage_header" type="text" name="start[header_${data.system.locales[i]}]" id="start_header_${data.system.locales[i]}">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-9">
                  <div class="form-group mb-3 ms-2">
                    <label for="trix_startpage_description_${data.system.locales[i]}">
                      ${I18n.t('webshop.settings.startpage_description')}
                      | ${I18n.t(`language.${data.system.locales[i]}`)}
                    </label><br>
                    <input type="hidden" name="start[description_${data.system.locales[i]}]" id="start_description_${data.system.locales[i]}">
                    <div class="trix-content">
                      <trix-editor id="trix_startpage_description_${data.system.locales[i]}" class="description" input="start_description_${data.system.locales[i]}"  data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                      </trix-editor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-9">
                  <div class="form-group mb-3 ms-2">
                    <label for="trix_startpage_footer_${data.system.locales[i]}">
                      ${I18n.t('webshop.settings.startpage_footer')}
                      | ${I18n.t(`language.${data.system.locales[i]}`)}
                    </label><br>
                    <input type="hidden" name="start[footer_${data.system.locales[i]}]" id="start_footer_${data.system.locales[i]}">
                    <div class="trix-content">
                      <trix-editor id="trix_startpage_footer_${data.system.locales[i]}" class="" input="start_footer_${data.system.locales[i]}" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                      </trix-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `);
        }

        const languageTab = that.webshop_tabs_languagesTarget.querySelector(`button[data-bs-target="#language_${activeLanguage}"]`);
        if (languageTab) new bootstrap.Tab(languageTab).show();

        that.webshop_currenciesTarget.innerHTML = `<b>${data.system.currency}</b>`;
        for(let i = 0; i < data.system.currencies.length; i++) {
          if(data.system.currencies[i] == data.system.currency) {
            continue;
          }
          that.webshop_currenciesTarget.innerHTML += `<br>${data.system.currencies[i]}`
        }

        that.webshop_payment_gatewaysTarget.textContent = '';
        for (var key in data.system.payment_gateways) {
          var payment_gateway = data.system.payment_gateways[key];
          if(payment_gateway && payment_gateway.enabled) {
            switch(key) {
              case 'paypal':
                that.webshop_payment_gatewaysTarget.innerHTML += `PayPal<br>`
                break;
              case 'stripe':
                that.webshop_payment_gatewaysTarget.innerHTML += `Stripe<br>`
                break;
              case 'sumup':
                that.webshop_payment_gatewaysTarget.innerHTML += `SumUp<br>`
                break;
              case 'payrexx':
                that.webshop_payment_gatewaysTarget.innerHTML += `Payrexx<br>`
                break;
            }
          }
        }

        that.webshop_payment_methodsTarget.textContent = '';

        let g = 0;
        for (var key in data.system.payment) {
          var payment_method = data.system.payment[key];
          if(g > 0) {
            that.webshop_payment_methodsTarget.innerHTML += '<br>';
          }

          that.webshop_payment_methodsTarget.innerHTML += `<span class="badge bg-secondary">${countries.getName(key, that.locale)}</span><br>`

          for(let i = 0; i < payment_method.length; i++) {
            if(payment_method[i] == 'cards') {
              that.webshop_payment_methodsTarget.innerHTML += I18n.t(`payment_methods.card`)+'<br>';
            } else {
              that.webshop_payment_methodsTarget.innerHTML += I18n.t(`payment_methods.${payment_method[i]}`)+'<br>';
            }
          }

          g++;
        }

        that.webshop_templateTarget.textContent = '';
        switch(data.system.template) {
          case 'basic':
            that.webshop_templateTarget.innerHTML += `Basic`
            break;
          case 'advanced':
            that.webshop_templateTarget.innerHTML += `Advanced`

            that.startpage_sectionsTargets.forEach((el, i) => {
              el.classList.remove('d-none');
            });

            that.categoriesTargets.forEach((el, i) => {
              el.classList.remove('d-none');
            });

            break;
          case 'complete':
            that.webshop_templateTarget.innerHTML += `Complete`
            break;
        }

        if(data.system.vouchers && data.system.vouchers == true) {
          that.vouchersTarget.classList.remove("d-none");
        }

        const accountSettings = document.querySelector('#user-account-settings');
        if (accountSettings) {
          accountSettings.disabled = false;
          installUserAccountImage(accountSettings, data.config.find(entry => entry.attr === 'user_account')?.value || {});
        }

        for(let i = 0; i < data.config.length; i++ ) {
          switch(data.config[i].attr) {
            case 'user_account':
              document.querySelector('#user-account-enabled').checked = data.config[i].value.wishlist_enabled === true;
              document.querySelector('#user-account-login-required').checked = data.config[i].value.login_required === true;
              document.querySelector('#user-account-newsletter-enabled').checked = data.config[i].value.newsletter_enabled === true;
              break;
            case 'start.header':
              for(let j = 0; j < data.system.locales.length; j++) {
                let inp = document.querySelector(`input#start_header_${data.system.locales[j]}`);
                if(inp) {
                  if(data.config[i].value[data.system.locales[j]]) {
                    inp.value = data.config[i].value[data.system.locales[j]];
                  }
                }
              }
              break;
            case 'start.description':
              for(let j = 0; j < data.system.locales.length; j++) {
                let trix = document.querySelector(`#trix_startpage_description_${data.system.locales[j]}`);
                if(trix) {
                  if(data.config[i].value[data.system.locales[j]]) {
                    that.loadStartpageRichText(trix, data.config[i].value[data.system.locales[j]])
                  }
                }
              }
              break;
            case 'start.footer':
              for(let j = 0; j < data.system.locales.length; j++) {
                let trix = document.querySelector(`#trix_startpage_footer_${data.system.locales[j]}`);
                if(trix) {
                  if(data.config[i].value[data.system.locales[j]]) {
                    that.loadStartpageRichText(trix, data.config[i].value[data.system.locales[j]])
                  }
                }
              }
              break;
            case 'start.sections':
              that.shopStartpageSections(data.config[i], data.system.locale, data.system.locales)
              break;
          }
        }

        that.populateCategoryPresentation(data);
        that.renderShopShippingSettings(data);
        that.populateShopEditableSettings(data);
        that.populateSeoSettings(data);
        that.populateStartpageAppearance(data);
      },
      error: function(data) {}
    });
  }

  loadDeliveryDateRichText(element, html) {
    const input = document.getElementById(element.getAttribute('input'));
    if (input) input.value = html || '';
    const load = () => element.editor.loadHTML(html || '');
    if (element.editor) load();
    else element.addEventListener('trix-initialize', load, {once: true});
  }

  renderShopShippingSettings(data) {
    let shippingConfigs = {};
    let pickupConfig = {};
    let deliveryDateConfig = {};
    let deliveryTimeConfig = {};
    let countryCodes = [];

    (data.config || []).forEach((config) => {
      if(config.attr == 'shipping.delivery_time') deliveryTimeConfig = config.value || {};
      if(config.attr == 'shipping.delivery_date') {
        deliveryDateConfig = config.value || {};
      }
      if(config.attr == 'shipping.pickup') {
        pickupConfig = config.value || {};
      }
      let match = String(config.attr || '').match(/^shipping\.([a-z]{2})$/i);
      if(match) {
        let countryCode = match[1].toUpperCase();
        shippingConfigs[countryCode] = config.value || {};
        countryCodes.push(countryCode);
      }
    });

    if(data.system && Array.isArray(data.system.shipping_countries)) {
      countryCodes = countryCodes.concat(data.system.shipping_countries);
    }

    if(data.system && data.system.defaults && data.system.defaults.country) {
      Object.keys(data.system.defaults.country).forEach((country) => {
        let shippingCountries = data.system.defaults.country[country].shipping_countries;
        if(Array.isArray(shippingCountries)) {
          countryCodes = countryCodes.concat(shippingCountries);
        }
      });
    }

    countryCodes = [...new Set(countryCodes.map((country) => country.toString().toUpperCase()))]
      .filter((country) => /^[A-Z]{2}$/.test(country))
      .sort();

    this.webshop_shipping_settingsTarget.innerHTML = '';

    const orderShipping = document.createElement('div');
    orderShipping.className = 'form-check form-switch mb-4';
    orderShipping.dataset.orderWeightCalculation = '';
    const calculationEnabled = (data.config || []).find(row => row.attr === 'shipping.order_weight_calculation')?.value?.enabled === true;
    orderShipping.innerHTML = `<input type="hidden" name="webshop[order_weight_calculation]" value="0"><input type="checkbox" class="form-check-input" id="webshop_order_weight_calculation" name="webshop[order_weight_calculation]" value="1" ${calculationEnabled ? 'checked' : ''}><label class="form-check-label" for="webshop_order_weight_calculation">${I18n.t('order_shipping.enable')}</label><div class="form-text small">${I18n.t('order_shipping.enable_help')}</div>`;

    let pickupCard = document.createElement('div');
    pickupCard.className = 'card mb-4';
    pickupCard.innerHTML = `
      <div class="card-body">
        <h2 class="fs-6 mb-3">${I18n.t('webshop.shipping.pickup')}</h2>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" value="1" id="webshop_shipping_pickup_enabled" name="webshop[pickup][enabled]">
          <label class="form-check-label" for="webshop_shipping_pickup_enabled">${I18n.t('webshop.shipping.pickup_enabled')}</label>
        </div>
        <div class="row g-3">
          <div class="col-12 col-md-8">
            <label class="form-label" for="webshop_shipping_pickup_location">${I18n.t('webshop.shipping.pickup_location')}</label>
            <input class="form-control" type="text" id="webshop_shipping_pickup_location" name="webshop[pickup][location]">
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label" for="webshop_shipping_pickup_price">${I18n.t('webshop.shipping.pickup_price')}</label>
            <div class="input-group">
              <input class="form-control" type="number" min="0" step="0.01" required id="webshop_shipping_pickup_price" name="webshop[pickup][price]">
              <span class="input-group-text">${data.system.currency || ''}</span>
            </div>
          </div>
        </div>
        <div class="form-text small mt-2">
          <i class="fa-duotone fa-circle-info"></i>
          ${I18n.t('webshop.shipping.pickup_help')}
        </div>
      </div>
    `;
    pickupCard.querySelector('#webshop_shipping_pickup_enabled').checked = [true, 1, '1', 'true', 'on'].includes(pickupConfig.enabled);
    pickupCard.querySelector('#webshop_shipping_pickup_location').value = pickupConfig.location || '';
    pickupCard.querySelector('#webshop_shipping_pickup_price').value = pickupConfig.price == null ? 0 : pickupConfig.price;
    this.webshop_shipping_settingsTarget.append(pickupCard);

    let deliveryDateCard = document.createElement('div');
    deliveryDateCard.className = 'card mb-4';
    deliveryDateCard.innerHTML = `
      <div class="card-body">
        <h2 class="fs-6 mb-3">${I18n.t('webshop.shipping.delivery_date')}</h2>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" value="1" id="webshop_shipping_delivery_date_enabled" name="webshop[delivery_date][enabled]">
          <label class="form-check-label" for="webshop_shipping_delivery_date_enabled">${I18n.t('webshop.shipping.delivery_date_enabled')}</label>
        </div>
        <div class="form-check form-switch mb-3">
          <input class="form-check-input" type="checkbox" value="1" id="webshop_shipping_delivery_date_allow_weekends" name="webshop[delivery_date][allow_weekends]">
          <label class="form-check-label" for="webshop_shipping_delivery_date_allow_weekends">${I18n.t('webshop.shipping.delivery_date_allow_weekends')}</label>
        </div>
        <div class="form-check form-switch mb-3">
          <input type="hidden" name="webshop[delivery_date][show_delivery_time]" value="0">
          <input class="form-check-input" type="checkbox" value="1" id="webshop_shipping_show_delivery_time" name="webshop[delivery_date][show_delivery_time]">
          <label class="form-check-label" for="webshop_shipping_show_delivery_time">${I18n.t('webshop.shipping.item_delivery_time_enabled')}</label>
        </div>
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <label class="form-label" for="webshop_shipping_delivery_date_minimum_days">${I18n.t('webshop.shipping.delivery_date_minimum_days')}</label>
            <input class="form-control" type="number" min="14" step="1" required id="webshop_shipping_delivery_date_minimum_days" name="webshop[delivery_date][minimum_days]">
          </div>
        </div>
        <div class="form-text small mt-2">
          <i class="fa-duotone fa-circle-info"></i>
          ${I18n.t('webshop.shipping.delivery_date_help')}
        </div>
      </div>
    `;
    deliveryDateCard.querySelector('#webshop_shipping_delivery_date_enabled').checked = [true, 1, '1', 'true', 'on'].includes(deliveryDateConfig.enabled);
    deliveryDateCard.querySelector('#webshop_shipping_delivery_date_allow_weekends').checked = [true, 1, '1', 'true', 'on'].includes(deliveryDateConfig.allow_weekends);
    deliveryDateCard.querySelector('#webshop_shipping_show_delivery_time').checked = deliveryDateConfig.show_delivery_time == null || [true, 1, '1', 'true', 'on'].includes(deliveryDateConfig.show_delivery_time);
    let minimumDays = parseInt(deliveryDateConfig.minimum_days || 14, 10);
    if(!Number.isFinite(minimumDays) || minimumDays < 14) minimumDays = 14;
    deliveryDateCard.querySelector('#webshop_shipping_delivery_date_minimum_days').value = minimumDays;
    const commentSettings = document.createElement('div');
    commentSettings.className = 'mt-4';
    commentSettings.innerHTML = `<div class="form-check form-switch mb-3"><input type="hidden" name="webshop[delivery_date][comment_enabled]" value="0"><input class="form-check-input" type="checkbox" value="1" id="webshop_delivery_date_comment_enabled" name="webshop[delivery_date][comment_enabled]"><label class="form-check-label" for="webshop_delivery_date_comment_enabled">${I18n.t('webshop.shipping.delivery_date_comment_enabled')}</label></div>`;
    commentSettings.querySelector('[type="checkbox"]').checked = [true, 1, '1', 'true', 'on'].includes(deliveryDateConfig.comment_enabled);
    const commentTabs = document.createElement('div');
    commentTabs.className = 'nav nav-tabs';
    const commentPanes = document.createElement('div');
    commentPanes.className = 'tab-content';
    const commentLocales = ['de', 'en', 'fr', 'it', 'nl', 'es'];
    commentLocales.forEach((locale, index) => {
      const active = commentLocales.includes(this.locale) ? locale === this.locale : index === 0;
      const paneId = `shipping_comment_${locale}`;
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = `nav-link${active ? ' active' : ''}`;
      tab.dataset.bsToggle = 'tab';
      tab.dataset.bsTarget = `#${paneId}`;
      tab.textContent = I18n.t(`language.${locale}`);
      commentTabs.append(tab);
      const pane = document.createElement('div');
      pane.id = paneId;
      pane.className = `tab-pane py-3${active ? ' active show' : ''}`;
      const label = document.createElement('label');
      label.className = 'form-label';
      label.htmlFor = `${paneId}_text`;
      label.textContent = I18n.t('webshop.shipping.delivery_date_comment');
      const input = document.createElement('input');
      input.type = 'hidden';
      input.id = `${paneId}_input`;
      input.name = `webshop[delivery_date][comments][${locale}]`;
      input.value = deliveryDateConfig.comments?.[locale] || '';
      const editor = document.createElement('trix-editor');
      editor.id = label.htmlFor;
      editor.className = 'trix-content';
      editor.setAttribute('input', input.id);
      editor.dataset.locale = locale;
      editor.addEventListener('trix-file-accept', event => event.preventDefault());
      editor.addEventListener('trix-initialize', () => {
        const attachmentButton = editor.toolbarElement?.querySelector('[data-trix-action="attachFiles"]');
        if (attachmentButton) attachmentButton.hidden = true;
      });
      pane.append(label, input, editor);
      commentPanes.append(pane);
    });
    commentSettings.append(commentTabs, commentPanes);
    const format = document.createElement('input');
    format.type = 'hidden';
    format.name = 'webshop[delivery_date][comments_format]';
    format.value = 'html';
    commentSettings.append(format);
    deliveryDateCard.querySelector('.card-body').append(commentSettings);
    this.webshop_shipping_settingsTarget.append(deliveryDateCard);
    const timeCard = document.createElement('div');
    timeCard.className = 'card mb-4';
    timeCard.innerHTML = `<div class="card-body"><h2 class="fs-6 mb-3">${I18n.t('webshop.delivery_time.title')}</h2>
      <input type="hidden" name="webshop[delivery_time][enabled]" value="0">
      <div class="form-check form-switch mb-3"><input class="form-check-input" type="checkbox" id="webshop_delivery_time_enabled" name="webshop[delivery_time][enabled]" value="1"><label class="form-check-label" for="webshop_delivery_time_enabled">${I18n.t('webshop.delivery_time.enabled')}</label></div>
      <div class="row"><div class="col-12 col-md-4"><label class="form-label" for="webshop_delivery_time_price">${I18n.t('webshop.delivery_time.price')}</label><div class="input-group"><input class="form-control" type="number" min="0" max="1000000" step="0.01" required id="webshop_delivery_time_price" name="webshop[delivery_time][price]"><span class="input-group-text">${data.system.currency || ''}</span></div></div></div>
      <p class="form-text mb-0">${I18n.t('webshop.delivery_time.help')}</p></div>`;
    timeCard.querySelector('#webshop_delivery_time_enabled').checked = deliveryTimeConfig.enabled === true;
    timeCard.querySelector('#webshop_delivery_time_price').value = deliveryTimeConfig.price == null ? 0 : deliveryTimeConfig.price;
    this.webshop_shipping_settingsTarget.append(timeCard);
    commentSettings.querySelectorAll('trix-editor').forEach(editor => {
      const value = deliveryDateConfig.comments?.[editor.dataset.locale] || '';
      const plain = document.createElement('div');
      plain.textContent = value;
      const html = deliveryDateConfig.comments_format === 'html' ? value : plain.innerHTML.replace(/\r?\n/g, '<br>');
      this.loadDeliveryDateRichText(editor, html);
    });

    if(countryCodes.length == 0) {
      this.webshop_shipping_settingsTarget.append(orderShipping);
      let notice = document.createElement('div');
      notice.className = 'alert alert-light border';
      notice.textContent = I18n.t('webshop.shipping.no_countries');
      this.webshop_shipping_settingsTarget.append(notice);
      return;
    }

    let selectorGroup = document.createElement('div');
    let selector = document.createElement('select');
    let selectorLabel = document.createElement('label');

    selectorGroup.className = 'mb-4';
    selectorLabel.className = 'form-label';
    selectorLabel.htmlFor = 'webshop_shipping_country';
    selectorLabel.textContent = I18n.t('webshop.shipping.country');
    selector.className = 'form-select';
    selector.id = 'webshop_shipping_country';
    selector.dataset.action = 'change->settings#shopShippingCountryChanged';
    selectorGroup.append(selectorLabel, selector);
    this.webshop_shipping_settingsTarget.append(selectorGroup);

    countryCodes.forEach((countryCode, countryIndex) => {
      let country = countryCode.toLowerCase();
      let config = shippingConfigs[countryCode] || {};
      let calculation = config.calculation == 'weight' ? 'weight' : 'order_value';
      let card = document.createElement('div');
      let option = document.createElement('option');

      option.value = country;
      option.textContent = `${countries.getName(countryCode, this.locale) || countryCode} (${countryCode})`;
      selector.append(option);

      card.className = 'card mb-3 webshop-shipping-country';
      if(countryIndex > 0) card.classList.add('d-none');
      card.dataset.shippingCountry = country;
      card.dataset.nextStepIndex = '0';
      card.innerHTML = `
        <div class="card-header fw-semibold">
          <span data-shipping-country-name></span>
          <span class="badge bg-secondary ms-2">${countryCode}</span>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <label class="form-label" for="webshop_shipping_${country}_calculation">${I18n.t('webshop.shipping.calculation')}</label>
              <select class="form-select" id="webshop_shipping_${country}_calculation" name="webshop[shipping][${country}][calculation]" data-action="change->settings#shopShippingCalculationChanged">
                <option value="order_value">${I18n.t('webshop.shipping.calculation_order_value')}</option>
                <option value="weight">${I18n.t('webshop.shipping.calculation_weight')}</option>
              </select>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="webshop_shipping_${country}_default">${I18n.t('webshop.shipping.default_price')}</label>
              <div class="input-group">
                <input class="form-control" type="number" min="0" step="0.01" required id="webshop_shipping_${country}_default" name="webshop[shipping][${country}][default]">
                <span class="input-group-text" data-shipping-currency></span>
              </div>
            </div>
          </div>

          <div class="form-text small mt-3">
            <i class="fa-duotone fa-circle-info"></i>
            ${I18n.t('webshop.help.shipping')}
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-sm align-middle mb-2">
              <thead>
                <tr>
                  <th data-shipping-threshold-label></th>
                  <th>${I18n.t('webshop.shipping.price')}</th>
                  <th class="text-end"><span class="visually-hidden">${I18n.t('btn.delete')}</span></th>
                </tr>
              </thead>
              <tbody data-shipping-steps></tbody>
            </table>
          </div>

          <button type="button" class="btn btn-sm btn-outline-secondary" data-action="click->settings#shopAddShippingStep">
            <i class="fa-solid fa-plus"></i> ${I18n.t('webshop.shipping.add_step')}
          </button>
        </div>
      `;

      card.querySelector('[data-shipping-country-name]').textContent = countries.getName(countryCode, this.locale) || countryCode;
      card.querySelector('[data-shipping-currency]').textContent = data.system.currency || '';
      card.querySelector('select').value = calculation;
      card.querySelector('input[type="number"]').value = config.default == null ? 0 : config.default;
      this.updateShopShippingThresholdLabel(card);
      this.webshop_shipping_settingsTarget.append(card);
      if (countryIndex === 0) card.querySelector('.card-body').prepend(orderShipping);

      (config.steps || []).forEach((step) => {
        this.appendShopShippingStep(card, step);
      });
    });
  }

  populateSeoSettings(data) {
    const config = (data.config || []).find((entry) => entry.attr === 'seo.settings');
    const settings = config?.value || {};
    ['show', 'show_header'].forEach((field) => {
      const input = this.element.querySelector(`#blog_${field}`);
      const entry = (data.config || []).find((row) => row.attr === `blog.${field}`);
      if(input && entry) input.checked = entry.value === true;
    });
    ['ai_search', 'ai_training', 'llms', 'structured_data'].forEach((field) => {
      const input = this.element.querySelector(`#seo_${field}`);
      if(input) input.checked = settings[field] !== false;
    });
    const vat = this.element.querySelector('#seo_vat_id');
    if(vat) vat.value = settings.vat_id ?? (data.system?.vatid || '');
    this.element.querySelectorAll('[data-seo-texts]').forEach((container) => {
      const section = container.dataset.seoTexts;
      const activePane = container.querySelector('.tab-pane.active');
      const activeLocale = activePane?.dataset.locale || data.system?.locale;
      const fields = section === 'blog' ? ['blog_title', 'blog_description'] : ['description'];
      container.replaceChildren();
      const tabs = document.createElement('div');
      tabs.className = 'nav nav-tabs';
      tabs.setAttribute('role', 'tablist');
      const content = document.createElement('div');
      content.className = 'tab-content';
      const locales = data.system?.locales || [];
      locales.forEach((locale, index) => {
        const active = locales.includes(activeLocale) ? locale === activeLocale : index === 0;
        const paneId = `seo_${section}_language_${locale}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `nav-item nav-link${active ? ' active' : ''}`;
        button.id = `${paneId}_tab`;
        button.dataset.bsTarget = `#${paneId}`;
        button.dataset.bsToggle = 'tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', paneId);
        button.setAttribute('aria-selected', String(active));
        button.textContent = I18n.t(`language.${locale}`);
        tabs.append(button);
        const pane = document.createElement('div');
        pane.className = `tab-pane pt-3${active ? ' active show' : ''}`;
        pane.id = paneId;
        pane.dataset.locale = locale;
        pane.setAttribute('role', 'tabpanel');
        pane.setAttribute('aria-labelledby', button.id);
        fields.forEach((field) => {
          const label = document.createElement('label');
          label.className = 'form-label';
          label.htmlFor = `seo_${field}_${locale}`;
          label.textContent = I18n.t(`webshop.seo.${field}`);
          const input = document.createElement(field === 'blog_title' ? 'input' : 'textarea');
          input.className = 'form-control mb-3';
          input.id = label.htmlFor;
          input.name = `webshop[seo][texts][${locale}][${field}]`;
          input.maxLength = field === 'blog_title' ? 200 : 1000;
          input.value = settings.texts?.[locale]?.[field] || '';
          pane.append(label, input);
        });
        content.append(pane);
      });
      container.append(tabs, content);
    });
    const preview = this.element.querySelector('[data-blog-image-preview]');
    if(preview) {
      preview.replaceChildren();
      if(settings.blog_image) {
        const image = document.createElement('img');
        image.src = settings.blog_image;
        image.alt = I18n.t('webshop.seo.blog_image');
        image.className = 'img-fluid rounded';
        image.style.maxHeight = '180px';
        preview.append(image);
      }
    }
    this.element.querySelectorAll('[data-seo-save]').forEach((save) => { save.disabled = false; });
  }

  populateShopEditableSettings(data) {
    let configs = {};

    (data.config || []).forEach((config) => {
      if(config && typeof config.attr == 'string') {
        configs[config.attr] = config.value;
      }
    });

    let system = data.system || {};
    let items = system.items || {};
    let itemShow = items.show || {};
    let stock = system.stock || {};
    let configured = (attribute, fallback) => Object.prototype.hasOwnProperty.call(configs, attribute) ? configs[attribute] : fallback;
    let setValue = (id, value) => {
      let input = this.element.querySelector(`#${id}`);
      if(input) input.value = value == null ? '' : value;
    };
    let setChecked = (id, value) => {
      let input = this.element.querySelector(`#${id}`);
      if(input) input.checked = [true, 1, '1', 'true', 'on'].includes(value);
    };

    let tabOrder = configured('items.show.tab_order', itemShow.tab_order || ['description_long', 'properties']);
    if(!Array.isArray(tabOrder) || tabOrder.length != 2) {
      tabOrder = ['description_long', 'properties'];
    }
    setValue('webshop_settings_tab_order', tabOrder.join(','));
    setValue('webshop_settings_stock_min_threshold', configured('stock.min_threshold', stock.min_threshold == null ? 5 : stock.min_threshold));
    setValue('webshop_settings_currency_format', configured('currency.format', 'post'));

    let cardContent = configured('items.card.content', items.card && items.card.content ? items.card.content : {}) || {};
    ['description', 'color', 'size'].forEach((field) => {
      setChecked(`webshop_settings_card_content_${field}`, cardContent[field]);
    });

    let cardVariants = configured('items.card.variants', items.card && items.card.variants ? items.card.variants : {}) || {};
    ['colors', 'sizes'].forEach((field) => {
      setChecked(`webshop_settings_card_variants_${field}`, cardVariants[field]);
    });

    setValue('webshop_settings_unit_steps', configured('items.unit_steps', items.unit_steps));
    setChecked('webshop_settings_show_packaging_content', configured('items.show_packaging_content', items.show_packaging_content));

    let contact = configured('contact.details', system.contact || {}) || {};
    setValue('webshop_settings_contact_company', contact.company ?? system.company);
    setValue('webshop_settings_contact_address', contact.address);
    setValue('webshop_settings_contact_email', contact.email);
    setValue('webshop_settings_contact_phone', contact.phone);

    let social = configured('social.links', system.social || {}) || {};
    ['google', 'facebook', 'instagram', 'twitter', 'linkedin', 'youtube', 'pinterest'].forEach((provider) => {
      setValue(`webshop_settings_social_${provider}`, social[provider]);
    });

    this.webshop_editable_settingsTarget.disabled = false;
  }

  shopAddShippingStep(event) {
    let card = event.currentTarget.closest('[data-shipping-country]');
    this.appendShopShippingStep(card, {});
  }

  shopRemoveShippingStep(event) {
    event.currentTarget.closest('tr').remove();
  }

  shopShippingCalculationChanged(event) {
    let card = event.currentTarget.closest('[data-shipping-country]');
    this.updateShopShippingThresholdLabel(card);
  }

  shopShippingCountryChanged(event) {
    let selectedCountry = event.currentTarget.value;
    const orderShipping = this.webshop_shipping_settingsTarget.querySelector('[data-order-weight-calculation]');
    this.webshop_shipping_settingsTarget.querySelectorAll('[data-shipping-country]').forEach((card) => {
      card.classList.toggle('d-none', card.dataset.shippingCountry != selectedCountry);
      if (orderShipping && card.dataset.shippingCountry === selectedCountry) card.querySelector('.card-body').prepend(orderShipping);
    });
  }

  appendShopShippingStep(card, step) {
    let country = card.dataset.shippingCountry;
    let index = parseInt(card.dataset.nextStepIndex || '0');
    let row = document.createElement('tr');

    card.dataset.nextStepIndex = index + 1;
    row.innerHTML = `
      <td>
        <input class="form-control form-control-sm" type="number" min="0" step="0.01" required name="webshop[shipping][${country}][steps][${index}][value]">
      </td>
      <td>
        <input class="form-control form-control-sm" type="number" min="0" step="0.01" required name="webshop[shipping][${country}][steps][${index}][price]">
      </td>
      <td class="text-end">
        <button type="button" class="btn btn-sm btn-outline-danger" title="${I18n.t('btn.delete')}" data-action="click->settings#shopRemoveShippingStep">
          <i class="fa-solid fa-trash"></i>
        </button>
      </td>
    `;

    row.querySelectorAll('input')[0].value = step.value == null ? '' : step.value;
    row.querySelectorAll('input')[1].value = step.price == null ? '' : step.price;
    card.querySelector('[data-shipping-steps]').append(row);
  }

  updateShopShippingThresholdLabel(card) {
    let calculation = card.querySelector('select').value;
    let key = calculation == 'weight' ? 'threshold_weight' : 'threshold_order_value';
    card.querySelector('[data-shipping-threshold-label]').textContent = I18n.t(`webshop.shipping.${key}`);
  }

  shopPageFooterCategory(page) {
    let configuredCategory = page.data && page.data.footer_category;
    if(['general', 'about', 'more'].includes(configuredCategory)) return configuredCategory;

    if(page.system && ['support', 'services', 'delivery', 'payment'].includes(page.page)) return 'general';
    if(page.system && ['legal', 'terms', 'privacy'].includes(page.page)) return 'about';

    return 'more';
  }

  shopFooterCategoryOptions(selectedCategory) {
    return ['general', 'about', 'more'].map((category) => {
      let selected = category == selectedCategory ? ' selected' : '';
      return `<option value="${category}"${selected}>${I18n.t(`webshop.page.footer_category_${category}`)}</option>`;
    }).join('');
  }

  loadShopPages(uuid) {
    // alert('loadShopPages');

    var that = this;

    Rails.ajax({
      url: `/${this.locale}/webshop/${uuid}/pages`,
      type: "get",
      success: function(data) {
        that.webshop_pagesTarget.innerHTML = "";
        if(data.length > 0) {
          data.forEach((page, i) => {
            let ctr_str = '';
            if(page.data && page.data.countries) {
              page.data.countries.map((country) => {
                ctr_str += `<span class="badge bg-secondary ms-1" title="${countries.getName(country, that.locale)}">${country.toUpperCase()}</span>`
              })
            }
            let pageContent = page.content && page.content[I18n.locale] ? page.content[I18n.locale] : (page.content ? page.content[Object.keys(page.content)[0]] : null);
            let pageTitle = pageContent ? pageContent.title || '' : '';
            let footerCategory = that.shopPageFooterCategory(page);
            let li = document.createElement("li");
            li.classList.add("list-group-item")
            li.setAttribute("data-enabled", page.enabled)
            li.setAttribute("data-uuid", page.uuid)
            li.innerHTML = `
              <div class="d-flex justify-content-between">
                <span class="flex-grow">
                  ${page.system ? `${I18n.t(`webshop.page.${page.page}`)} <span class="small text-secondary ms-2">${I18n.t("webshop.system")}</span>` : ''}
                  ${!page.system ? pageTitle : ''}
                  ${ctr_str}
                  <span class="badge bg-light text-dark ms-1">${I18n.t(`webshop.page.footer_category_${footerCategory}`)}</span>
                </span>
                <div>
                  <span class="enabled smaller">
                    ${page.enabled ? `<span class="badge bg-success"><i class="fa-solid fa-check fa-fw"></i> ${I18n.t('webshop.page.active')}</span>` : `<span class="badge bg-secondary"><i class="fa-solid fa-xmark fa-fw"></i> ${I18n.t('webshop.page.inactive')}</span>`}
                  </span>

                  <button type="button" class="btn btn-sm btn-outline-secondary ms-1" data-uuid="${page.uuid}" data-action="click->settings#shopEditPage">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger ms-1" data-uuid="${page.uuid}" data-title="${pageTitle}" data-action="click->settings#shopDeleteConfirmPage" ${page.system ? 'disabled' : ''}>
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            `
            that.webshop_pagesTarget.append(li);
          });
        }
      },
      error: function(data) {}
    });
  }

  shopNewPage() {
    let that = this;

    let html = `
      <h6 class="mb-0">${I18n.t('webshop.page.page')}</h6>
      <div class="row">
        <div class="col">
          <div class="form-check my-3">
            <input class="form-check-input" type="checkbox" value="" id="enabled" checked>
            <label class="form-check-label" for="enabled">
              ${I18n.t('webshop.page.active')}
            </label>
          </div>
        </div>
        <div class="col">
          <div class="form-check my-3">
            <input class="form-check-input" type="checkbox" value="" id="navigation">
            <label class="form-check-label" for="navigation">
              ${I18n.t('webshop.page.show_in_navigation')}
            </label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="footer_category">${I18n.t('webshop.page.footer_category')}</label>
        <select class="form-select" id="footer_category">
          ${this.shopFooterCategoryOptions('more')}
        </select>
        <div class="form-text">${I18n.t('webshop.page.footer_category_help')}</div>
      </div>
      <h6 class="mt-3 mb-0">${I18n.t('subscription.countries')}</h6>
      <div class="row">
    `;

    that.countries.forEach((country, i) => {
      html += `
          <div class="col">
            <div class="form-check my-3">
              <input class="form-check-input country" type="checkbox" value="${country}" id="country_${country}" ${country == that.country ? 'checked' : ''}>
              <label class="form-check-label" for="country_${country}">
                ${countries.getName(country, that.locale)}
              </label>
            </div>
          </div>
      `;
    });
    html += `
      </div>
      <div class="mb-4">
        <label class="form-label" for="page_image">${I18n.t('webshop.page_editor.image')}</label>
        <input type="file" class="form-control" id="page_image">
      </div>
      <div class="accordion" id="pagesContent">
    `

    this.locales.forEach((locale, i) => {
      html += `
        <div class="accordion-item" data-locale="${locale}">
          <input type="hidden" id="content_${locale}" value=''>
          <h2 class="accordion-header">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#${locale}" aria-expanded="${i == 0 ? 'true' : 'false'}" aria-controls="${locale}">
              ${I18n.t(`language.${locale}`)}
            </button>
          </h2>
          <div id="${locale}" class="accordion-collapse collapse ${i == 0 ? 'show' : ''}" data-bs-parent="#pagesContent">
            <div class="accordion-body">
              <label for="title" class="form-label">${I18n.t('webshop.page.page')}</label>
              <input id="title_${locale}" type="text" class="form-control mb-4" value="" required>
                  <div class="form-check mb-4">
                    <input class="form-check-input" type="checkbox" id="show_title_${locale}" data-page-show-title checked>
                    <label class="form-check-label" for="show_title_${locale}">${I18n.t('webshop.page_editor.show_title')}</label>
                  </div>
                  <label class="form-label" for="url_${locale}">${I18n.t('webshop.page_editor.url')}</label>
                  <input id="url_${locale}" class="form-control" maxlength="200" pattern="[a-z0-9]+(-[a-z0-9]+)*" placeholder="fliesenberatung">
                  <div class="form-text mb-3">${I18n.t('webshop.page_editor.url_help')}</div>
                  <label class="form-label" for="meta_title_${locale}">${I18n.t('webshop.seo.meta_title')}</label>
                  <input id="meta_title_${locale}" class="form-control mb-3" maxlength="200">
                  <label class="form-label" for="meta_description_${locale}">${I18n.t('webshop.seo.meta_description')}</label>
                  <textarea id="meta_description_${locale}" class="form-control mb-4" maxlength="1000"></textarea>
              <div class="trix-content">
                <trix-editor input="content_${locale}" style="min-height:450px;max-height:60vh;overflow:auto;" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                </trix-editor>
              </div>
            </div>
          </div>
        </div>
      `
    });

    html += `
      </div>
    `

    var box = bootbox.dialog({
      title: I18n.t('webshop.page.page'),
      message: html,
      onEscape: true,
      size: 'xl',
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        apply: {
          label: I18n.t('btn.save'),
          className: "btn-success",
          callback: function() {
                const invalidURL = Array.from(box[0].querySelectorAll('[id^="url_"]')).find(input => !input.checkValidity());
                if (invalidURL) { invalidURL.closest('.accordion-collapse').classList.add('show'); invalidURL.reportValidity(); return false; }
            let enabled = box[0].querySelector('#enabled').checked
            let navigationMenu = box[0].querySelector('#navigation').checked
            let footerCategory = box[0].querySelector('#footer_category').value
            let countries = [];
            box[0].querySelectorAll(".form-check-input.country:checked").forEach((chk, i) => {
              countries.push(chk.value)
            });

            let json = {
              enabled: enabled,
              navigation: navigationMenu,
              show_title: box[0].querySelector('[data-page-show-title]').checked,
                  image_alt: box[0].querySelector('#page_image_alt').value,
              footer_category: footerCategory,
              countries: countries
            }

            box[0].querySelectorAll('div.accordion-item').forEach((div, i) => {
              let locale = div.dataset.locale;
              let entry = {
                url: div.querySelector(`[id="url_${locale}"]`).value.trim(),
                title: div.querySelector(`input#title_${locale}`).value,
                  meta_title: div.querySelector('[id^="meta_title_"]')?.value || '',
                  meta_description: div.querySelector('[id^="meta_description_"]')?.value || '',
                content: div.querySelector(`input#content_${locale}`).value
              };
              let overviewEl = div.querySelector(`input#overview_${locale}`);
              if (overviewEl) {
                entry.overview_text = overviewEl.value;
              }
              json[locale] = entry;
            });

            var fd = new FormData();
            fd.append("webshop", that.uuid);
            fd.append("content", JSON.stringify(json));
                const pageImage = box[0].querySelector('#page_image').files[0];
                if (pageImage) fd.append("image", pageImage);

            Rails.ajax({
              url: `/${that.locale}/webshop/page`,
              type: "post",
              data: fd,
              success: function(data) {
                that.loadShopPages(that.uuid);
                box.modal('hide');
                business.showAlert('success', I18n.t('webshop.message.page_saved'));
              },
              error: function(data) {
                business.showAlert('danger', I18n.t('webshop.page_editor.save_error'));
              }
            });
            return false;
          }
        }
      }
    });
    installPageImages(box[0], that);
  }

  shopEditPage() {
    let that = this;
    let li = event.target.closest('li');
    let page = li.dataset.uuid;

    Rails.ajax({
      url: `/${this.locale}/webshop/${this.uuid}/page/${page}`,
      type: "get",
      success: function(data) {
        let json = data.content;
        let html = `
          <h6 class="mb-0">${I18n.t('webshop.page.page')}</h6>
          <div class="row">
            <div class="col">
              <div class="form-check my-3">
                <input class="form-check-input" type="checkbox" value="" id="enabled" ${li.dataset.enabled == 'true' ? 'checked' : ''}>
                <label class="form-check-label" for="enabled">
                  ${I18n.t('webshop.page.active')}
                </label>
              </div>
            </div>
          `
        if(!data.system) {
          html += `
            <div class="col">
              <div class="form-check my-3">
                <input class="form-check-input" type="checkbox" value="" id="navigation" ${(data.data && data.data.navigation) ? 'checked' : ''}>
                <label class="form-check-label" for="navigation">
                  ${I18n.t('webshop.page.show_in_navigation')}
                </label>
              </div>
            </div>
          `
        }
        html += `
          </div>
          <div class="mb-3">
            <label class="form-label" for="footer_category">${I18n.t('webshop.page.footer_category')}</label>
            <select class="form-select" id="footer_category">
              ${that.shopFooterCategoryOptions(that.shopPageFooterCategory(data))}
            </select>
            <div class="form-text">${I18n.t('webshop.page.footer_category_help')}</div>
          </div>
        `
        if(!data.system) {
          html += `
            <h6 class="mt-3 mb-0">${I18n.t('subscription.countries')}</h6>
            <div class="row">
          `
          that.countries.forEach((country, i) => {
            html += `
                <div class="col">
                  <div class="form-check my-3">
                    <input class="form-check-input country" type="checkbox" value="${country}" id="country_${country}" ${data.data.countries.includes(country) ? 'checked' : ''}>
                    <label class="form-check-label" for="country_${country}">
                      ${countries.getName(country, that.locale)}
                    </label>
                  </div>
                </div>
            `;
          });
          html += `
            </div>
          `
        }
        html += `
          <div class="mb-4">
        <label class="form-label" for="page_image">${I18n.t('webshop.page_editor.image')}</label>
        <input type="file" class="form-control" id="page_image">
      </div>
          <div class="accordion" id="pagesContent">
            <input type="hidden" id="uuid" value='${page}'>
        `

        that.locales.forEach((locale, i) => {
          let title;
          if(data.system) {
            title = I18n.t(`webshop.page.${data.page}`);
          } else {
            if(data.content[locale]) {
              title = data.content[locale].title;
            } else {
              title = '';
            }
          }
          html += `
            <div class="accordion-item" data-locale="${locale}">
              <input type="hidden" id="content_${locale}" value=''>
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#${locale}" aria-expanded="${i == 0 ? 'true' : 'false'}" aria-controls="${locale}">
                  ${I18n.t(`language.${locale}`)}
                </button>
              </h2>
              <div id="${locale}" class="accordion-collapse collapse ${i == 0 ? 'show' : ''}" data-bs-parent="#pagesContent">
                <div class="accordion-body">
                  <label for="title" class="form-label">${I18n.t('webshop.page.page')}</label>
                  <input id="title_${locale}" type="text" class="form-control mb-4" value="${title}" required ${data.system ? 'readonly' : ''}>
                  <div class="form-check mb-4">
                    <input class="form-check-input" type="checkbox" id="show_title_${locale}" data-page-show-title ${data.data?.show_title === true ? 'checked' : ''}>
                    <label class="form-check-label" for="show_title_${locale}">${I18n.t('webshop.page_editor.show_title')}</label>
                  </div>
                  ${!data.system ? `                  <label class="form-label" for="url_${locale}">${I18n.t('webshop.page_editor.url')}</label>
                  <input id="url_${locale}" class="form-control" maxlength="200" pattern="[a-z0-9]+(-[a-z0-9]+)*" placeholder="fliesenberatung">
                  <div class="form-text mb-3">${I18n.t('webshop.page_editor.url_help')}</div>
` : ''}
                  <label class="form-label" for="meta_title_${locale}">${I18n.t('webshop.seo.meta_title')}</label>
                  <input id="meta_title_${locale}" class="form-control mb-3" maxlength="200">
                  <label class="form-label" for="meta_description_${locale}">${I18n.t('webshop.seo.meta_description')}</label>
                  <textarea id="meta_description_${locale}" class="form-control mb-4" maxlength="1000"></textarea>
                  <div class="trix-content">
                    <trix-editor input="content_${locale}" style="min-height:450px;max-height:60vh;overflow:auto;" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                    </trix-editor>
                  </div>
                </div>
              </div>
            </div>
          `
        });

        html += `
          </div>
        `

        var box = bootbox.dialog({
          title: I18n.t('webshop.page.page'),
          message: html,
          onEscape: true,
          size: 'xl',
          buttons: {
            cancel: {
              label: I18n.t('btn.cancel'),
              className: "btn-outline-secondary",
            },
            apply: {
              label: I18n.t('btn.save'),
              className: "btn-success",
              callback: function() {
                const invalidURL = Array.from(box[0].querySelectorAll('[id^="url_"]')).find(input => !input.checkValidity());
                if (invalidURL) { invalidURL.closest('.accordion-collapse').classList.add('show'); invalidURL.reportValidity(); return false; }
                let uuid = box[0].querySelector('input#uuid').value
                let enabled = box[0].querySelector('#enabled').checked
                let footerCategory = box[0].querySelector('#footer_category').value
                let navigationMenu = false;
                if(box[0].querySelector('#navigation')) {
                  navigationMenu = box[0].querySelector('#navigation').checked
                }

                let countries = [];
                box[0].querySelectorAll(".form-check-input.country:checked").forEach((chk, i) => {
                  countries.push(chk.value)
                });

                let json = {
                  uuid: uuid,
                  enabled: enabled,
                  navigation: navigationMenu,
                  show_title: box[0].querySelector('[data-page-show-title]').checked,
                  image_alt: box[0].querySelector('#page_image_alt').value,
                  footer_category: footerCategory,
                  countries: countries
                }

                box[0].querySelectorAll('div.accordion-item').forEach((div, i) => {
                  json[div.dataset.locale] = {
                    title: div.querySelector(`input#title_${div.dataset.locale}`).value,
                  meta_title: div.querySelector('[id^="meta_title_"]')?.value || '',
                  meta_description: div.querySelector('[id^="meta_description_"]')?.value || '',
                    content: div.querySelector(`input#content_${div.dataset.locale}`).value
                  }
                  const urlInput = div.querySelector('[id^="url_"]');
                  if (urlInput) json[div.dataset.locale].url = urlInput.value.trim();
                });

                var fd = new FormData();
                fd.append("webshop", that.uuid);
                fd.append("content", JSON.stringify(json));
                const pageImage = box[0].querySelector('#page_image').files[0];
                if (pageImage) fd.append("image", pageImage);

                Rails.ajax({
                  url: `/${that.locale}/webshop/page`,
                  type: "post",
                  data: fd,
                  success: function(data) {
                    that.loadShopPages(that.uuid);
                    box.modal('hide');
                    business.showAlert('success', I18n.t('webshop.message.page_saved'));
                  },
                  error: function(data) {
                    business.showAlert('danger', I18n.t('webshop.page_editor.save_error'));
                  }
                });
                return false;
              }
            }
          },
          onShown: function(e) {
            installPageImages(e.target, that, data);
            e.target.querySelectorAll('div.accordion-item').forEach((div, i) => {
              let el = div.querySelector('trix-editor');
              if(data.content[div.dataset.locale]) {
                ['url', 'meta_title', 'meta_description'].forEach((field) => {
                  const input = div.querySelector(`[id="${field}_${div.dataset.locale}"]`);
                  if(input) input.value = data.content[div.dataset.locale][field] || '';
                });
                el.editor.insertHTML(data.content[div.dataset.locale].content);
              }
            });

          }
        });
      },
      error: function(data) {
        business.showAlert('danger', I18n.t('webshop.page_editor.save_error'));
      }
    });
  }

  loadShopBlogs(uuid) {
    var that = this;

    Rails.ajax({
      url: `/${this.locale}/blogs/${uuid}`,
      type: "get",
      success: function(data) {
        that.webshop_blogsTarget.innerHTML = "";
        if(data && data.length > 0) {
          data.forEach((blog, i) => {
            if (blog.page === 'blog' || (blog.data && blog.data.type === 'blog')) {
              let ctr_str = '';
              if(blog.data && blog.data.countries) {
                blog.data.countries.map((country) => {
                  ctr_str += `<span class="badge bg-secondary ms-1" title="${countries.getName(country, that.locale)}">${country.toUpperCase()}</span>`
                })
              }
              let li = document.createElement("li");
              li.classList.add("list-group-item")
              li.setAttribute("data-enabled", blog.enabled)
              li.setAttribute("data-uuid", blog.uuid)
              li.innerHTML = `
                <div class="d-flex justify-content-between">
                  <span class="flex-grow">
                    ${!blog.system && blog.content[I18n.locale] ? blog.content[I18n.locale].title : ''}
                    ${ctr_str}
                  </span>
                  <div>
                    <span class="enabled smaller">
                      ${blog.enabled ? `<span class="badge bg-success"><i class="fa-solid fa-check fa-fw"></i> ${I18n.t('webshop.page.active')}</span>` : `<span class="badge bg-secondary"><i class="fa-solid fa-xmark fa-fw"></i> ${I18n.t('webshop.page.inactive')}</span>`}
                    </span>

                    <button type="button" class="btn btn-sm btn-outline-secondary ms-1" data-uuid="${blog.uuid}" data-action="click->settings#blogEditPage">
                      <i class="fa-solid fa-pen"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger ms-1" data-uuid="${blog.uuid}" data-title="${blog.content[I18n.locale].title}" data-action="click->settings#blogDeleteConfirmPage">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </div>
              `
              that.webshop_blogsTarget.append(li);
            }
          });
        }
      },
      error: function(data) {}
    });
  }

  blogNewPage() {
    let that = this;

    let html = `
      <h6 class="mb-0">${I18n.t('webshop.blog.blog')}</h6>
      <div class="row">
        <div class="col">
          <div class="form-check my-3">
            <input class="form-check-input" type="checkbox" value="" id="enabled" checked>
            <label class="form-check-label" for="enabled">
              ${I18n.t('webshop.page.active')}
            </label>
          </div>
        </div>
        <div class="col">
          <div class="form-check my-3">
            <input class="form-check-input" type="checkbox" value="" id="navigation">
            <label class="form-check-label" for="navigation">
              ${I18n.t('webshop.page.show_in_navigation')}
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label class="form-label" for="blog_image">${I18n.t('webshop.blog_images.cover')}</label>
          <input type="file" class="form-control" id="blog_image">
        </div>
      </div>

      <h6 class="mt-3 mb-0">${I18n.t('subscription.countries')}</h6>
      <div class="row">
    `;

    that.countries.forEach((country, i) => {
      html += `
          <div class="col">
            <div class="form-check my-3">
              <input class="form-check-input country" type="checkbox" value="${country}" id="country_${country}" ${country == that.country ? 'checked' : ''}>
              <label class="form-check-label" for="country_${country}">
                ${countries.getName(country, that.locale)}
              </label>
            </div>
          </div>
      `;
    });
    html += `
      </div>
      <div class="accordion" id="pagesContent">
    `

    this.locales.forEach((locale, i) => {
      html += `
        <div class="accordion-item" data-locale="${locale}">
          <input type="hidden" id="content_${locale}" value=''>
          <h2 class="accordion-header">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#${locale}" aria-expanded="${i == 0 ? 'true' : 'false'}" aria-controls="${locale}">
              ${I18n.t(`language.${locale}`)}
            </button>
          </h2>
          <div id="${locale}" class="accordion-collapse collapse ${i == 0 ? 'show' : ''}" data-bs-parent="#pagesContent">
            <div class="accordion-body">
              <label for="title" class="form-label">${I18n.t('blog.title')}</label>
              <input id="title_${locale}" type="text" class="form-control mb-4" value="" required>
                  <label class="form-label" for="url_${locale}">${I18n.t('webshop.seo.blog_slug')}</label>
                  <input id="url_${locale}" class="form-control mb-1" maxlength="200" pattern="[a-z0-9]+(-[a-z0-9]+)*">
                  <div class="form-text mb-3">${I18n.t('webshop.seo.blog_slug_help')}</div>
                  <label class="form-label" for="meta_title_${locale}">${I18n.t('webshop.seo.meta_title')}</label>
                  <input id="meta_title_${locale}" class="form-control mb-3" maxlength="200">
                  <label class="form-label" for="meta_description_${locale}">${I18n.t('webshop.seo.meta_description')}</label>
                  <textarea id="meta_description_${locale}" class="form-control mb-4" maxlength="1000"></textarea>
              <label for="overview_${locale}" class="form-label">${I18n.t('blog.overview_text')}</label>
              <input type="hidden" id="overview_${locale}" value=''>
              <div class="trix-content mb-4">
                <trix-editor input="overview_${locale}" style="min-height:100px;max-height:200px;overflow:auto;" placeholder="${I18n.t('blog.overview_text_placeholder')}">
                </trix-editor>
              </div>
              <label for="content_${locale}" class="form-label">${I18n.t('blog.content')}</label>
              <input type="hidden" id="content_${locale}" value=''>
              <div class="trix-content">
                <trix-editor input="content_${locale}" style="min-height:450px;max-height:60vh;overflow:auto;">
                </trix-editor>
              </div>
            </div>
          </div>
        </div>
      `
    });

    html += `
      </div>
    `

    var box = bootbox.dialog({
      title: I18n.t('webshop.blog.blog'),
      message: html,
      onEscape: true,
      size: 'xl',
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        apply: {
          label: I18n.t('btn.save'),
          className: "btn-success",
          callback: function() {
            let enabled = box[0].querySelector('#enabled').checked
            let navigationMenu = box[0].querySelector('#navigation').checked
            let countries = [];
            box[0].querySelectorAll(".form-check-input.country:checked").forEach((chk, i) => {
              countries.push(chk.value)
            });

            let json = {
              image_link: box[0].querySelector('#blog_image_link')?.value || '',
              image_alt: box[0].querySelector('#blog_image_alt')?.value || '',
              image_width: box[0].querySelector('#blog_image_width')?.value || '',
              enabled: enabled,
              navigation: navigationMenu,
              countries: countries,
              page: 'blog',
              data: {
                type: 'blog'
              }
            }

            box[0].querySelectorAll('div.accordion-item').forEach((div, i) => {
              json[div.dataset.locale] = {
                title: div.querySelector(`input#title_${div.dataset.locale}`).value,
                  url: div.querySelector('[id^="url_"]')?.value || '',
                  meta_title: div.querySelector('[id^="meta_title_"]')?.value || '',
                  meta_description: div.querySelector('[id^="meta_description_"]')?.value || '',
                content: div.querySelector(`input#content_${div.dataset.locale}`).value,
                overview_text: div.querySelector(`input#overview_${div.dataset.locale}`).value
              }
            });

            var fd = new FormData();
            fd.append("webshop", that.uuid);
            fd.append("content", JSON.stringify(json));

            let blogImageInput = box[0].querySelector('#blog_image');
            if (blogImageInput && blogImageInput.files.length > 0) {
              fd.append("image", blogImageInput.files[0]);
            }

            Rails.ajax({
              url: `/${that.locale}/blog`,
              type: "post",
              data: fd,
              success: function(data) {
                that.loadShopBlogs(that.uuid);
                box.modal('hide');
                business.showAlert('success', I18n.t('webshop.message.page_saved'));
              },
              error: function(data) {
                business.showAlert('danger', I18n.t('webshop.message.page_save_error'));
              }
            });
                return false;
          }
        }
      }
    });
    installBlogImages(box[0], that);
  }

  blogEditPage() {
    let that = this;
    let li = event.target.closest('li');
    let page = li.dataset.uuid;

    Rails.ajax({
      url: `/${this.locale}/blog/${this.uuid}/${page}`,
      type: "get",
      success: function(data) {
        let json = data.content;
        let html = `
          <h6 class="mb-0">${I18n.t('webshop.blog.blog')}</h6>
          <div class="row">
            <div class="col">
              <div class="form-check my-3">
                <input class="form-check-input" type="checkbox" value="" id="enabled" ${li.dataset.enabled == 'true' ? 'checked' : ''}>
                <label class="form-check-label" for="enabled">
                  ${I18n.t('webshop.page.active')}
                </label>
              </div>
            </div>
          `
        if(!data.system) {
          html += `
            <div class="col">
              <div class="form-check my-3">
                <input class="form-check-input" type="checkbox" value="" id="navigation" ${(data.data && data.data.navigation) ? 'checked' : ''}>
                <label class="form-check-label" for="navigation">
                  ${I18n.t('webshop.page.show_in_navigation')}
                </label>
              </div>
            </div>
          `
        }
        html += `
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label" for="blog_image">${I18n.t('webshop.blog_images.cover')}</label>
              <input type="file" class="form-control" id="blog_image">
            </div>
          </div>
        `
        if(!data.system) {
          html += `
            <h6 class="mt-3 mb-0">${I18n.t('subscription.countries')}</h6>
            <div class="row">
          `
          that.countries.forEach((country, i) => {
            html += `
                <div class="col">
                  <div class="form-check my-3">
                    <input class="form-check-input country" type="checkbox" value="${country}" id="country_${country}" ${data.data.countries.includes(country) ? 'checked' : ''}>
                    <label class="form-check-label" for="country_${country}">
                      ${countries.getName(country, that.locale)}
                    </label>
                  </div>
                </div>
            `;
          });
          html += `
            </div>
          `
        }
        html += `
          <div class="accordion" id="pagesContent">
            <input type="hidden" id="uuid" value='${page}'>
        `

        that.locales.forEach((locale, i) => {
          let title;
          if(data.system) {
            title = I18n.t(`webshop.blog.${data.page}`);
          } else {
            if(data.content[locale]) {
              title = data.content[locale].title;
            } else {
              title = '';
            }
          }
          html += `
            <div class="accordion-item" data-locale="${locale}">
              <input type="hidden" id="content_${locale}" value=''>
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#${locale}" aria-expanded="${i == 0 ? 'true' : 'false'}" aria-controls="${locale}">
                  ${I18n.t(`language.${locale}`)}
                </button>
              </h2>
              <div id="${locale}" class="accordion-collapse collapse ${i == 0 ? 'show' : ''}" data-bs-parent="#pagesContent">
                <div class="accordion-body">
                  <label for="title" class="form-label">${I18n.t('webshop.blog.title')}</label>
                  <input id="title_${locale}" type="text" class="form-control mb-4" value="${title}" required ${data.system ? 'readonly' : ''}>
                  <label class="form-label" for="url_${locale}">${I18n.t('webshop.seo.blog_slug')}</label>
                  <input id="url_${locale}" class="form-control mb-1" maxlength="200" pattern="[a-z0-9]+(-[a-z0-9]+)*">
                  <div class="form-text mb-3">${I18n.t('webshop.seo.blog_slug_help')}</div>
                  <label class="form-label" for="meta_title_${locale}">${I18n.t('webshop.seo.meta_title')}</label>
                  <input id="meta_title_${locale}" class="form-control mb-3" maxlength="200">
                  <label class="form-label" for="meta_description_${locale}">${I18n.t('webshop.seo.meta_description')}</label>
                  <textarea id="meta_description_${locale}" class="form-control mb-4" maxlength="1000"></textarea>
                  <label for="overview_${locale}" class="form-label">${I18n.t('blog.overview_text')}</label>
                  <input type="hidden" id="overview_${locale}" value=''>
                  <div class="trix-content mb-4">
                    <trix-editor class="overview-editor" input="overview_${locale}" style="min-height:100px;max-height:200px;overflow:auto;" placeholder="${I18n.t('blog.overview_text_placeholder')}">
                    </trix-editor>
                  </div>
                  <label for="content_${locale}" class="form-label">${I18n.t('blog.content')}</label>
                  <input type="hidden" id="content_${locale}" value=''>
                  <div class="trix-content">
                    <trix-editor class="content-editor" input="content_${locale}" style="min-height:450px;max-height:60vh;overflow:auto;">
                    </trix-editor>
                  </div>
                </div>
              </div>
            </div>
          `
        });

        html += `
          </div>
        `

        var box = bootbox.dialog({
          title: I18n.t('webshop.blog.blog'),
          message: html,
          onEscape: true,
          size: 'xl',
          buttons: {
            cancel: {
              label: I18n.t('btn.cancel'),
              className: "btn-outline-secondary",
            },
            apply: {
              label: I18n.t('btn.save'),
              className: "btn-success",
              callback: function() {
                let uuid = box[0].querySelector('input#uuid').value
                let enabled = box[0].querySelector('#enabled').checked
                let navigationMenu = false;
                if(box[0].querySelector('#navigation')) {
                  navigationMenu = box[0].querySelector('#navigation').checked
                }

                let countries = [];
                box[0].querySelectorAll(".form-check-input.country:checked").forEach((chk, i) => {
                  countries.push(chk.value)
                });

                let json = {
              image_link: box[0].querySelector('#blog_image_link')?.value || '',
              image_alt: box[0].querySelector('#blog_image_alt')?.value || '',
              image_width: box[0].querySelector('#blog_image_width')?.value || '',
                  uuid: uuid,
                  enabled: enabled,
                  navigation: navigationMenu,
                  countries: countries,
                  page: 'blog', // Mark this as a blog
                  data: {
                    type: 'blog'
                  }
                }

                box[0].querySelectorAll('div.accordion-item').forEach((div, i) => {
                  json[div.dataset.locale] = {
                    title: div.querySelector(`input#title_${div.dataset.locale}`).value,
                  url: div.querySelector('[id^="url_"]')?.value || '',
                  meta_title: div.querySelector('[id^="meta_title_"]')?.value || '',
                  meta_description: div.querySelector('[id^="meta_description_"]')?.value || '',
                    content: div.querySelector(`input#content_${div.dataset.locale}`).value,
                    overview_text: div.querySelector(`input#overview_${div.dataset.locale}`).value
                  }
                });

                var fd = new FormData();
                fd.append("webshop", that.uuid);
                fd.append("content", JSON.stringify(json));

                let blogImageInput = box[0].querySelector('#blog_image');
                if (blogImageInput && blogImageInput.files.length > 0) {
                  fd.append("image", blogImageInput.files[0]);
                }

                Rails.ajax({
                  url: `/${that.locale}/blog`,
                  type: "post",
                  data: fd,
                  success: function(data) {
                    that.loadShopBlogs(that.uuid)
                    box.modal('hide');
                    business.showAlert('success', I18n.t('webshop.message.page_saved'));
                  },
                  error: function(data) {
                    business.showAlert('danger', I18n.t('webshop.message.page_save_error'));
                  }
                });
                return false;
              }
            }
          },
          onShown: function(e) {
            installBlogImages(e.target, that, data);
            e.target.querySelectorAll('div.accordion-item').forEach((div, i) => {
              let contentEditor = div.querySelector('trix-editor.content-editor');
              let overviewEditor = div.querySelector('trix-editor.overview-editor');
              if(data.content[div.dataset.locale]) {
                ['url', 'meta_title', 'meta_description'].forEach((field) => {
                  const input = div.querySelector(`[id="${field}_${div.dataset.locale}"]`);
                  if(input) input.value = data.content[div.dataset.locale][field] || '';
                });
                if(contentEditor) {
                  contentEditor.editor.insertHTML(data.content[div.dataset.locale].content);
                }
                if(overviewEditor && data.content[div.dataset.locale].overview_text) {
                  overviewEditor.editor.insertHTML(data.content[div.dataset.locale].overview_text);
                }
              }
            });
          }
        });
      },
      error: function(data) {
        business.showAlert('danger', I18n.t('webshop.message.page_save_error'));
      }
    });
  }

  blogDeleteConfirmPage() {
    let that = this;
    let uuid = this.uuid;
    let page = event.target.dataset.uuid;
    let msg = event.target.dataset.title;

    bootbox.dialog({
      title: I18n.t('webshop.confirm.page_delete'),
      message: msg,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/blog/${uuid}/${page}`,
              type: "delete",
              data: "",
              success: function(data) {
                that.loadShopBlogs(uuid)
              },
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  loadShopVouchers(uuid) {
    var that = this;

    Rails.ajax({
      url: `/${this.locale}/webshop/${uuid}/vouchers`,
      type: "get",
      success: function(data) {
        if(data && data.length > 0) {
          data.forEach((voucher, i) => {
            let li = document.createElement("li");
            li.classList.add("list-group-item")
            li.setAttribute("data-enabled", voucher.enabled)
            li.setAttribute("data-uuid", voucher.uuid)
            li.innerHTML = `
              <div class="d-flex justify-content-between">
                <span class="flex-grow">
                  ${voucher.name} <span class="small text-secondary ms-2">${voucher.code}</span>
                  <span class="small ms-2">${voucher.amount ? `${voucher.currency} ${voucher.amount}` : `${voucher.percentage} %`}</span>
                </span>
                <div>
                  <span class="enabled smaller">
                    ${voucher.expired ? `<span class="badge bg-secondary"><i class="fa-solid fa-xmark fa-fw"></i> ${I18n.t('webshop.page.inactive')}</span>` : `<span class="badge bg-success"><i class="fa-solid fa-check fa-fw"></i> ${I18n.t('webshop.page.active')}</span>`}
                  </span>

                  <a href="/${I18n.locale}/webshop/${uuid}/voucher/${voucher.uuid}/edit" class="btn btn-sm btn-outline-secondary ms-1" data-remote="true">
                    <i class="fa-solid fa-pen"></i>
                  </a>
                  <button type="button" class="btn btn-sm btn-danger ms-1" data-uuid="${voucher.uuid}" data-name="${voucher.name}" data-code="${voucher.code}" data-action="click->settings#shopDeleteConfirmVoucher">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            `
            that.webshop_vouchersTarget.append(li);
          });
        } else {
          that.webshop_vouchersTarget.innerHTML = '';
        }
      },
      error: function(data) {

      }
    });
  }

  shopDeleteConfirmVoucher() {
    let that = this;
    let uuid = this.uuid;
    let voucher = event.target.dataset.uuid;
    let msg = `${event.target.dataset.name}<br><span class="small text-muted">${event.target.dataset.code}</span>`;

    bootbox.dialog({
      title: I18n.t('webshop.confirm.voucher_delete'),
      message: msg,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/webshop/${uuid}/voucher/${voucher}`,
              type: "delete",
              data: "",
              success: function(data) {
                that.loadShopVouchers(uuid)
              },
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  shopDeleteConfirmPage() {
    let that = this;
    let uuid = this.uuid;
    let page = event.target.dataset.uuid;
    let msg = event.target.dataset.title;

    bootbox.dialog({
      title: I18n.t('webshop.confirm.page_delete'),
      message: msg,
      onEscape: true,
      buttons: {
        cancel: {
          label: I18n.t('btn.cancel'),
          className: "btn-outline-secondary",
        },
        delete: {
          label: I18n.t('btn.delete'),
          className: "btn-danger",
          callback: function() {
            Rails.ajax({
              url: `/${that.locale}/webshop/${uuid}/page/${page}`,
              type: "delete",
              data: "",
              success: function(data) {
                that.loadShopPages(uuid)
              },
              error: function(data) {}
            });
            bootbox.hideAll();
          }
        }
      }
    });
  }

  shopStartpageSections(data, locale, locales) {
    Object.keys(data.value).forEach((country) => {
      let sections = data.value[country];
      for(let i = 0; i < sections.length; i++ ) {
        let html = `
          <div class="card mb-3 rounded-1" data-style="${sections[i].style}" data-uuid="${sections[i].uuid}" data-item="${sections[i].item}" style="max-width:600px;">
            <input type="hidden" id="uuid" value="${sections[i].uuid}">
            <input type="hidden" id="style" value="${sections[i].style}">
            <input type="hidden" id="item" value="${sections[i].item}">
            <input type="hidden" id="picture" value="${sections[i].picture}">
            <input type="hidden" id="thumbnail" value="${sections[i].thumbnail}">
            <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
              <div class="handle pointer-move-up-down p-2">
                <i class="fa-solid fa-grip-vertical fa-fw"></i>
              </div>
              <div class="ms-0 me-auto small semi-bold item">
                ${sections[i].item == 'product' ? I18n.t('item.item') : ''}
                ${sections[i].item == 'category' ? I18n.t('item.category.category') : ''}
              </div>
              <div class="mt-1">
                <button type="button" class="btn btn-xs btn-outline-secondary my-auto" data-action="click->settings#shopEditItem">
                  <i class="fa-solid fa-pen"></i>
                  ${I18n.t('btn.edit')}
                </button>
                <button type="button" class="btn btn-xs btn-danger my-auto me-1" data-action="click->settings#shopDeleteItem" data-index="${i}">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="card-body pt-0">
        `
        switch(sections[i].style) {
          case 'single-left':
            html += `
              <div class="d-flex justify-content-between small border-bottom mb-2">
                <div data-header="style">
                  <i class="fa-solid fa-mattress-pillow fa-rotate-180"></i> ${I18n.t('webshop.sections.single_left')}
                </div>
                <div>
            `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="locales_${i}" id="locale_${i}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                  <label class="form-check-label" for="locale_${i}_${locales[l]}">
                    ${locales[l].toUpperCase()}
                  </label>
                </div>
              `
            }
            html += `
                </div>
              </div>
              <div class="d-flex justify-content-between">
            `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="content smaller pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="${sections[i][locales[l]] ? sections[i][locales[l]].url : ''}">
                  <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${i}" value="${sections[i][locales[l]] ? sections[i][locales[l]].name : '-'}" readonly>
                  <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                    ${sections[i][locales[l]] ? sections[i][locales[l]].description.trim() : '-'}
                  </div>
                </div>
              `
            }
            html += `
                <figure class="figure" style="max-height:200px;max-width:200px;">
                  <img src="${sections[i].thumbnail}" class="figure-img img-fluid rounded-1">
                </figure>
              </div>
            `
            break;
          case 'single-right':
            html += `
              <div class="d-flex justify-content-between small border-bottom mb-2">
                <div data-header="style">
                  <i class="fa-solid fa-mattress-pillow"></i> ${I18n.t('webshop.sections.single_right')}
                </div>
                <div>
            `
              for(let l = 0; l < locales.length; l++) {
                html += `
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="locales_${i}" id="locale_${i}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                    <label class="form-check-label" for="locale_${i}_${locales[l]}">
                      ${locales[l].toUpperCase()}
                    </label>
                  </div>
                `
              }
              html += `
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <figure class="figure" style="max-height:200px;max-width:200px;">
                    <img src="${sections[i].thumbnail}" class="figure-img img-fluid rounded-1">
                  </figure>
              `
              for(let l = 0; l < locales.length; l++) {
                html += `
                  <div class="content smaller ps-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="${sections[i][locales[l]] ? sections[i][locales[l]].url : ''}">
                    <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${i}" value="${sections[i][locales[l]] ? sections[i][locales[l]].name : '-'}" readonly>
                    <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                      ${sections[i][locales[l]] ? sections[i][locales[l]].description.trim() : ''} &nbsp;
                    </div>
                  </div>
                `
              }
            html += `
              </div>
            `
            break;
          case 'banner':
            html += `
              <div class="d-flex justify-content-between small border-bottom mb-2">
                <div data-header="style">
                  <i class="fa-solid fa-image"></i>
                  ${I18n.t('webshop.sections.banner')}
                </div>
                <div>
            `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="locales_${i}" id="locale_${i}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                  <label class="form-check-label" for="locale_${i}_${locales[l]}">
                    ${locales[l].toUpperCase()}
                  </label>
                </div>
              `
            }
            html += `
                </div>
              </div>
              <figure class="figure w-100 me-2 text-center">
                <img src="${sections[i].thumbnail}" class="figure-img img-fluid rounded-1" style="max-height:250px;">
              </figure>
            `

            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="content smaller pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="${sections[i][locales[l]] ? sections[i][locales[l]].url : ''}">
                  <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${i}" value="${sections[i][locales[l]] ? sections[i][locales[l]].name : '-'}" readonly>
                  <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                    ${sections[i][locales[l]] ? sections[i][locales[l]].description.trim() : '-'}
                  </div>
                </div>
                `
            }
            break;
          case 'gallery':
          case 'list':
            html += `
              <div class="d-flex justify-content-between small border-bottom mb-2">
                <div data-header="style">
                  <i class="fa-solid ${sections[i].style == "list" ? "fa-ellipsis" : "fa-ellipsis-stroke"}"></i>
                  ${I18n.t(`webshop.sections.${sections[i].style}`)}
                </div>
              <div>
            `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="locales_${i}" id="locale_${i}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                  <label class="form-check-label" for="locale_${i}_${locales[l]}">
                    ${locales[l].toUpperCase()}
                  </label>
                </div>
              `
            }
            html += `
                </div>
              </div>
            `

            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="content smaller mb-2 pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}">
                  <input type="text" class="form-control-plaintext form-control-sm border p-1 ${sections[i].style == "gallery" ? "d-none" : ""}" id="header" value="${sections[i][locales[l]] ? sections[i][locales[l]].header : ''}" readonly>
                </div>
                `
            }

            html += `
              <div class="d-flex justify-content-between items">
            `
            for(let ii = 0; ii < sections[i].items.length; ii++) {
              let item = sections[i].items[ii];

              html += `
                <div class="item">
                  <input type="hidden" name="items[]" id="uuid" value="${item.uuid}">
                  <input type="hidden" name="items[]" id="style" value="${item.style}">
                  <input type="hidden" name="items[]" id="item" value="${item.item}">
                  <input type="hidden" name="items[]" id="picture" value="${item.picture}">
                  <input type="hidden" name="items[]" id="thumbnail" value="${item.thumbnail}">

                  <figure class="figure me-2" style="max-height:150px;max-width:150px;">
                    <img src="${item['thumbnail']}" class="figure-img img-fluid rounded-1">
              `
              for(let l = 0; l < locales.length; l++) {
                html += `
                    <figcaption class="figure-caption small ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="${sections[i][locales[l]] ? sections[i][locales[l]].url : ''}">
                      ${item[locales[l]] ? item[locales[l]].name : '-'}
                    </figcaption>
                `
              }
              html += `
                  </figure>
              `

              for(let l = 0; l < locales.length; l++) {
                html += `
                  <input type="hidden" name="items[]" id="name_${locales[l]}" value="${item[locales[l]] ? item[locales[l]].name : '-'}">
                  <input type="hidden" name="items[]" id="description_${locales[l]}" value="${item[locales[l]] ? item[locales[l]].description : '-'}">
                `
              }
              html += `
                </div>
              `
            }
            html += `
              </div>
            `
            break;
        }
        html += `
            </div>
          </div>
        `

        let div = this.webshop_tab_content_startpage_countriesTarget.querySelector(`#startpage_country_${country}`);
        div.innerHTML += html;
      }
    })

    this.webshop_tab_content_startpage_countriesTarget.querySelectorAll("div.tab-pane").forEach((div, i) => {
      new Sortable(div, {
          handle: '.handle',
          animation: 150,
      });
    });
  }

  shopToggleLocale() {
    let locale = event.target.dataset.locale;
    let div = event.target.closest('div.card')
    div.querySelectorAll('div.content').forEach((div, i) => {
      if(div.dataset.locale == locale) {
        div.classList.remove('d-none');
      } else {
        div.classList.add('d-none');
      }
    });
    div.querySelectorAll('figcaption.figure-caption').forEach((figure, i) => {
      if(figure.dataset.locale == locale) {
        figure.classList.remove('d-none');
      } else {
        figure.classList.add('d-none');
      }
    });
  }

  shopEditItem() {
    let that = this;
    let card = event.target.closest('.card');

    let style = card.dataset.style;

    let locale = this.locale
    if(card.querySelector('input:checked')) {
      locale = card.querySelector('input:checked').value;
    } else {
      card.querySelector('input[type=radio]').checked = true;
      locale = card.querySelector('input:checked').value;
    }

    let item = card.dataset.item;
    let items = card.querySelectorAll('div.items > .item')

    let inp_uuid = card.querySelector('input#uuid')
    let inp_item = card.querySelector('input#item')
    let inp_style = card.querySelector('input#style');
    let inp_image = card.querySelector('input#picture')
    let inp_thumbnail = card.querySelector('input#thumbnail')

    let url;
    if(item == 'product') {
      url = `/${this.locale}/item/${inp_uuid.value}.json?images=true`;
    } else {
      url = `/${this.locale}/item/category/${inp_uuid.value}`
    }

    Rails.ajax({
      url: url,
      type: "get",
      success: function(data) {
        window.toggleStyle = function() {
          let sectionsList = document.querySelector('.bootbox-body').querySelectorAll("section[data-view=style-list]");
          let sectionsNonList = document.querySelector('.bootbox-body').querySelectorAll("section[data-view=style-nonlist]");
          if(event.target.value == 'list' || event.target.value == 'gallery') {
            sectionsNonList.forEach((section, i) => {
              section.classList.add('d-none');
            });
            sectionsList.forEach((section, i) => {
              section.classList.remove('d-none');

              let nav = section.querySelector("div.nav.nav-tabs")
              let navContent = section.querySelector("div.tab-content");
              if(nav) {
                if(event.target.value == 'list') {
                  nav.classList.remove('d-none');
                  navContent.classList.remove('d-none');
                } else {
                  nav.classList.add('d-none');
                  navContent.classList.add('d-none');
                }
              }
            });
          } else {
            sectionsList.forEach((section, i) => {
              section.classList.add('d-none');
            });
            sectionsNonList.forEach((section, i) => {
              section.classList.remove('d-none');
            });
          }
        }
        window.listDeleteItem = function() {
          event.target.closest('div.item').remove()

          let modal = document.querySelector(".bootbox-body")
          let style = modal.querySelector("input#style").value;
          if(style == 'gallery') {
            let divItems = modal.querySelector("div.items");

            if(divItems.children.length < 4) {
              document.querySelectorAll('button.btn-xs.add').forEach((btn, i) => {
                btn.removeAttribute("disabled")
              });
            }
          }
        }

        let i18n;
        let div_item = card.querySelector("div.small.item");
        let div_header = card.querySelector("div[data-header='style']");
        let div_items = card.querySelector("div.items");

        let item = card.querySelector("input#item").value;
        let style = card.querySelector("input#style").value;
        let name = []

        let html = `
          <input id="style" type="hidden" value="${style}">
          <input id="uuid" type="hidden" value="${inp_uuid.value}">
          <input id="item" type="hidden" value="${item}">
        `;

        for(let l = 0; l < that.locales.length; l++) {
          card.querySelectorAll(`div[data-locale="${that.locales[l]}"]`).forEach((div, i) => {
            if(div.querySelector('input.form-control-plaintext')) {
              name.push(div.querySelector('input.form-control-plaintext').value);
            }
            if(div.querySelector("div.trix-content")) {
              html += `<input id="edit_description_${that.locales[l]}" type="hidden" name="content" value="${div.querySelector("div.trix-content").innerHTML.trim()}">`
            }
          });
        }

        let image = card.querySelector("img.figure-img");

        if(data && data.i18n) {
          let arr = data.i18n.filter(i18n => {
            return i18n.locale == locale;
          });

          i18n = {}
          if(arr.length > 0) {
            i18n = arr[0];
          }
        }

        html += `
          <div class="d-flex justify-content-start mb-3 pb-2 border-bottom">
            <div class="form-check ps-1">
              <input class="form-check-input ms-2 mb-1" type="radio" name="style" id="single-left" value="single-left" ${style == 'single-left' ? 'checked' : ''} onclick="toggleStyle()">
              <label class="form-check-label smaller" for="single-left">
                <i class="fa-solid fa-mattress-pillow fa-rotate-180 ms-1"></i> ${I18n.t('webshop.sections.single_left')}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input ms-2 mb-1" type="radio" name="style" id="single-right" value="single-right" ${style == 'single-right' ? 'checked' : ''} onclick="toggleStyle()">
              <label class="form-check-label smaller" for="single-right">
                <i class="fa-solid fa-mattress-pillow ms-1"></i> ${I18n.t('webshop.sections.single_right')}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input ms-2 mb-1" type="radio" name="style" id="banner" value="banner" ${style == 'banner' ? 'checked' : ''} onclick="toggleStyle()">
              <label class="form-check-label smaller" for="banner">
                <i class="fa-solid fa-image ms-1"></i>
                ${I18n.t('webshop.sections.banner')}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input ms-2 mb-1" type="radio" name="style" id="gallery" value="gallery" ${style == 'gallery' ? 'checked' : ''} onclick="toggleStyle()">
              <label class="form-check-label smaller" for="gallery">
                <i class="fa-solid fa-ellipsis-stroke ms-1"></i>
                ${I18n.t('webshop.sections.gallery')}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input ms-2 mb-1" type="radio" name="style" id="list" value="list" ${style == 'list' ? 'checked' : ''} onclick="toggleStyle()">
              <label class="form-check-label smaller" for="list">
                <i class="fa-solid fa-ellipsis ms-1"></i>
                ${I18n.t('webshop.sections.list')}
              </label>
            </div>
          </div>
          <section data-view="style-nonlist" class="${(style == 'list' || style == 'gallery') ? 'd-none' : ''}">
            <div class="nav nav-tabs" role="tablist">
          `

          for(let l = 0; l < that.locales.length; l++) {
            html += `
              <button class="nav-item nav-link smaller ${l == 0 ? 'active' : ''}" type="button" data-bs-target="#section_${that.locales[l]}" role="tab" data-bs-toggle="tab" aria-selected="${l == 0 ? 'true' : ''}">
                ${I18n.t(`language.${that.locales[l]}`)}
              </button>
            `
          }
          html += `
            </div>
            <div class="tab-content">
            `
          for(let l = 0; l < that.locales.length; l++) {
            html += `
              <div role="tabpanel" class="tab-pane pt-2 ps-2 pe-2 ${l == 0 ? 'active show' : ''}" id="section_${that.locales[l]}">
                <div class="d-flex justify-content-between mb-3" data-controller="settings">
                  <div class="flex-fill">
                    <label for="item" class="form-label">
                      ${item == 'product' ? I18n.t('item.item') : I18n.t('item.category.category')}
                    </label>
                    <input type="text" class="form-control-plaintext" value="${i18n ? i18n.name : ''}" readonly>
                  </div>
                  <button type="button" class="btn btn-xs btn-outline-secondary my-auto text-nowrap" data-action="click->settings#shopSelectItem">
                    <i class="fa-solid fa-search"></i>
                    ${I18n.t('item.item')}
                  </button>
                  <button type="button" class="btn btn-xs btn-outline-secondary ms-2 my-auto text-nowrap" data-action="click->settings#shopSelectCategory">
                    <i class="fa-solid fa-search"></i>
                    ${I18n.t('item.category.category')}
                  </button>
                </div>
                <label for="name" class="form-label">${I18n.t('item.name')}</label>
                <input id="edit_name_${that.locales[l]}" type="text" name="name" class="form-control form-control-sm mb-3" value="${name[l]}">

                <label for="description" class="form-label">${I18n.t('item.description')}</label>
                <div class="trix-content">
                  <trix-editor input="edit_description_${that.locales[l]}" style="min-height:300px;" data-direct-upload-url="${that.directUrlValue}" data-blob-url-template="${that.blobUrlTemplateValue}">
                  </trix-editor>
                </div>
              </div>
            `
          }
          html += `
              </div>
            </section>
            <section data-view="style-list" class="${(style == 'list' || style == 'gallery') ? '' : 'd-none'}">
            <div class="nav nav-tabs ${style == 'list' ? '' : 'd-none'}" role="tablist">
          `

          for(let l = 0; l < that.locales.length; l++) {
            html += `
              <button class="nav-item nav-link smaller ${l == 0 ? 'active' : ''}" type="button" data-bs-target="#section_list_${that.locales[l]}" role="tab" data-bs-toggle="tab" aria-selected="${l == 0 ? 'true' : ''}">
                ${I18n.t(`language.${that.locales[l]}`)}
              </button>
            `
          }

          html += `
            </div>
            <div class="tab-content mb-4 ${style == 'list' ? '' : 'd-none'}">
            `

          for(let l = 0; l < that.locales.length; l++) {
            let header = card.querySelector(`div[data-locale="${that.locales[l]}"]`).querySelector('input.form-control-plaintext');
            if(header) {
              html += `
                <div role="tabpanel" class="tab-pane pt-2 ps-2 pe-2 ${l == 0 ? 'active show' : ''}" id="section_list_${that.locales[l]}">
                  <label for="header" class="form-label">${I18n.t('webshop.header')}</label>
                  <input type="text" class="form-control form-control-sm" name="header" id="header_${that.locales[l]}" data-locale="${that.locales[l]}" value="${header.value}">
                </div>
              `
            }
          }

          html += `
            </div>
          `

          html += `
            <div class="mb-4 ms-2" data-controller="settings">
              <button type="button" class="btn btn-xs btn-outline-secondary my-auto text-nowrap add" data-action="click->settings#shopSelectItem" ${(style == "gallery" && items.length >= 4) ? 'disabled' : ''}>
                <i class="fa-solid fa-plus"></i>
                ${I18n.t('item.item')}
              </button>
              <button type="button" class="btn btn-xs btn-outline-secondary ms-2 my-auto text-nowrap add" data-action="click->settings#shopSelectCategory" ${(style == "gallery" && items.length >= 4) ? 'disabled' : ''}>
                <i class="fa-solid fa-plus"></i>
                ${I18n.t('item.category.category')}
              </button>
            </div>
            <div class="d-flex justify-content-start ms-2 items">
        `
            for(let ii = 0; ii < items.length; ii++) {
              let uuid = items[ii].querySelector("input#uuid").value;
              let item = items[ii].querySelector("input#item").value;
              let picture = items[ii].querySelector("input#picture").value;
              let thumbnail = items[ii].querySelector("input#thumbnail").value;
              let name = []
              let description = []

              for(let l = 0; l < that.locales.length; l++) {
                name.push(items[ii].querySelector(`input#name_${that.locales[l]}`).value)
                description.push(items[ii].querySelector(`input#description_${that.locales[l]}`).value)
              }

              let width = "160px";
              if(style == "gallery") {
                width = "24%";
              }

              html += `
                <div class="item me-2" style="width:${width}">
                  <div class="position-absolute d-flex justify-content-between" style="">
                    <div class="handle p-1">
                      <i class="fa-solid fa-grip-vertical"></i>
                    </div>
                    <div>
                      <button type="button" class="btn btn-xs btn-danger" onclick="listDeleteItem()" tabindex=-1>
                        <i class="fa-solid fa-trash fa-fw"></i>
                      </button>
                    </div>
                  </div>

                  <input type="hidden" name="items[]" id="uuid" value="${uuid}">
                  <input type="hidden" name="items[]" id="style" value="">
                  <input type="hidden" name="items[]" id="item" value="${item}">
                  <input type="hidden" name="items[]" id="picture" value="${picture}">
                  <input type="hidden" name="items[]" id="thumbnail" value="${thumbnail}">

                  <figure class="figure me-2" style="max-height:90%;max-width:90%;">
                    <img src="${thumbnail}" class="figure-img img-fluid rounded-1">
                  </figure>

                  <div class="nav nav-tabs" role="tablist">
                `

                for(let l = 0; l < that.locales.length; l++) {

                  html += `
                    <button class="nav-item nav-link smaller ${l == 0 ? 'active' : ''}" type="button" data-bs-target="#item_${ii}_${that.locales[l]}" role="tab" data-bs-toggle="tab" aria-selected="${l == 0 ? 'true' : ''}">
                      ${that.locales[l].toUpperCase()}
                    </button>
                  `
                }
              html += `
                </div>
                <div class="tab-content mb-4">
              `

              for(let l = 0; l < that.locales.length; l++) {
                html += `
                  <div role="tabpanel" class="tab-pane pt-2 ps-2 pe-2 ${l == 0 ? 'active show' : ''}" id="item_${ii}_${that.locales[l]}">
                    <div class="input-group input-group-sm mb-3">
                      <span class="input-group-text">${that.locales[l].toUpperCase()}</span>
                      <input type="text" class="form-control form-control-sm" name="items[]" id="name" data-locale="${that.locales[l]}" value="${name[l]}">
                    </div>
                    <textarea class="form-control ${style == 'gallery' ? '' : 'd-none'}" name="items[]" id="description" data-locale="${that.locales[l]}" rows="3">${description[l]}</textarea>
                  </div>
                `
              }

              html += `
                  </div>
                </div>
              `
            }
        html += `
            </div>
          </section>
          <section data-view="style-nonlist" class="ms-2 ${(style == 'list' || style == 'gallery') ? 'd-none' : ''}">

            <label for="images" class="form-label mt-3 mb-0">${I18n.t('item.images')}</label><br>
            <div class="d-flex flex-wrap images">
          `
          if(data && data.images) {
            for(let i = 0; i < data.images.length; i++) {
              html += `
                <div>
                  <div class="form-check d-flex flex-column ps-0">
                    <input class="form-check-input ms-2 mb-1" type="radio" name="image" id="img${i}" data-uuid="${data.images[i].uuid}" data-image="${data.images[i].image ? data.images[i].image : data.images[i].picture}" data-thumbnail="${data.images[i].thumbnail}" ${data.images[i].thumbnail == image.src ? 'checked' : ''}>
                    <label class="form-check-label" for="img${i}">
                      <img src="${data.images[i].thumbnail}" class="img-thumbnail m-1" style="max-width:150px;max-height:150px;">
                    </label>
                  </div>
                </div>
              `
            }
          }
        html += `
            </div>
          </section>
        `
        var box = bootbox.dialog({
          title: I18n.t('webshop.settings.startpage_sections'),
          message: html,
          onEscape: true,
          size: 'xl',
          buttons: {
            cancel: {
              label: I18n.t('btn.cancel'),
              className: "btn-outline-secondary",
            },
            apply: {
              label: I18n.t('btn.apply'),
              className: "btn-success",
              callback: function() {
                if(inp_style.value == 'list') {
                  div_header.innerHTML = `
                    <i class="fa-solid fa-ellipsis ms-1"></i>
                    ${I18n.t('webshop.sections.list')}
                  `
                  for(let l = 0; l < that.locales.length; l++) {
                    card.querySelectorAll(`div[data-locale="${that.locales[l]}"]`).forEach((div, i) => {
                      div.querySelector('input.form-control-plaintext').value = document.querySelector('.bootbox-body').querySelector(`#header_${that.locales[l]}`).value;
                    });
                  }

                  div_items.innerHTML = ''
                  document.querySelectorAll('.bootbox-body .items > .item').forEach((item, i) => {
                    let html = `
                      <div class="item">
                        <input type="hidden" name="items[]" id="uuid" value="${item.querySelector("input#uuid").value}">
                        <input type="hidden" name="items[]" id="item" value="${item.querySelector("input#item").value}">
                        <input type="hidden" name="items[]" id="picture" value=${item.querySelector("input#picture").value}>
                        <input type="hidden" name="items[]" id="thumbnail" value=${item.querySelector("input#thumbnail").value}>

                        <figure class="figure me-2" style="max-height:150px;max-width:150px;">
                          <img src="${item.querySelector("input#thumbnail").value}" class="figure-img img-fluid rounded-1">
                      `
                    for(let l = 0; l < that.locales.length; l++) {
                      html += `
                        <figcaption class="figure-caption small ${that.locales[l] == locale ? '' : 'd-none'}" data-locale="${that.locales[l]}">
                          ${item.querySelector(`input#name[data-locale=${that.locales[l]}]`).value}
                        </figcaption>
                      `
                      }
                    html += `
                        </figure>
                      `

                    for(let l = 0; l < that.locales.length; l++) {
                      html += `
                        <input type="hidden" name="items[]" id="name_${that.locales[l]}" value="${item.querySelector(`input#name[data-locale=${that.locales[l]}]`).value}">
                        <input type="hidden" name="items[]" id="description_${that.locales[l]}" value="${item.querySelector(`textarea#description[data-locale=${that.locales[l]}]`).value}">
                      `
                    }

                    html += `
                      </div>
                    `
                    div_items.innerHTML += html;
                  });

                } else if(inp_style.value == 'gallery') {
                  div_header.innerHTML = `
                    <i class="fa-solid fa-ellipsis-stroke ms-1"></i>
                    ${I18n.t('webshop.sections.gallery')}
                  `
                  for(let l = 0; l < that.locales.length; l++) {
                    card.querySelectorAll(`div[data-locale="${that.locales[l]}"]`).forEach((div, i) => {
                      div.querySelector('input.form-control-plaintext').value = document.querySelector('.bootbox-body').querySelector(`#header_${that.locales[l]}`).value;
                    });
                  }

                  div_items.innerHTML = ''
                  document.querySelectorAll('.bootbox-body .items > .item').forEach((item, i) => {
                    let html = `
                      <div class="item">
                        <input type="hidden" name="items[]" id="uuid" value="${item.querySelector("input#uuid").value}">
                        <input type="hidden" name="items[]" id="item" value="${item.querySelector("input#item").value}">
                        <input type="hidden" name="items[]" id="picture" value=${item.querySelector("input#picture").value}>
                        <input type="hidden" name="items[]" id="thumbnail" value=${item.querySelector("input#thumbnail").value}>

                        <figure class="figure me-2" style="max-height:150px;max-width:150px;">
                          <img src="${item.querySelector("input#thumbnail").value}" class="figure-img img-fluid rounded-1">
                      `
                    for(let l = 0; l < that.locales.length; l++) {
                      html += `
                        <figcaption class="figure-caption small ${that.locales[l] == locale ? '' : 'd-none'}" data-locale="${that.locales[l]}">
                          ${item.querySelector(`input#name[data-locale=${that.locales[l]}]`).value}
                        </figcaption>
                      `
                      }
                    html += `
                        </figure>
                      `

                    for(let l = 0; l < that.locales.length; l++) {
                      html += `
                        <input type="hidden" name="items[]" id="name_${that.locales[l]}" value="${item.querySelector(`input#name[data-locale=${that.locales[l]}]`).value}">
                        <input type="hidden" name="items[]" id="description_${that.locales[l]}" value="${item.querySelector(`textarea#description[data-locale=${that.locales[l]}]`).value}">
                      `
                    }

                    html += `
                      </div>
                    `
                    div_items.innerHTML += html;
                  });

                } else {

                  inp_uuid.value = document.querySelector('.bootbox-body').querySelector("input#uuid").value;
                  inp_item.value = document.querySelector('.bootbox-body').querySelector("input#item").value;
                  inp_style.value = document.querySelector('.bootbox-body').querySelector("input[name=style]:checked").value;

                  if(inp_item.value == 'product') {
                    div_item.textContent = I18n.t('item.item');
                  }
                  if(inp_item.value == 'category') {
                    div_item.textContent = I18n.t('item.category.category');
                  }

                  switch(inp_style.value) {
                    case 'single-left':
                      div_header.innerHTML = `
                        <i class="fa-solid fa-mattress-pillow fa-rotate-180"></i> ${I18n.t('webshop.sections.single_left')}
                      `
                      break;
                    case 'single-right':
                      div_header.innerHTML = `
                        <i class="fa-solid fa-mattress-pillow"></i> ${I18n.t('webshop.sections.single_right')}
                      `
                      break;
                    case 'banner':
                      div_header.innerHTML = `
                        <i class="fa-solid fa-image"></i>
                        ${I18n.t('webshop.sections.banner')}
                      `
                      break;
                    case 'gallery':
                    case 'list':

                      break;
                  }

                  if(document.querySelector('.bootbox-body').querySelector('input[name=image]:checked')) {
                    inp_image.value = document.querySelector('.bootbox-body').querySelector('input[name=image]:checked').dataset.image;
                    inp_thumbnail.value = document.querySelector('.bootbox-body').querySelector('input[name=image]:checked').dataset.thumbnail;

                    image.src = inp_thumbnail.value;
                  }

                  for(let l = 0; l < that.locales.length; l++) {
                    card.querySelectorAll(`div[data-locale="${that.locales[l]}"]`).forEach((div, i) => {
                      div.querySelector('input.form-control-plaintext').value = document.querySelector('.bootbox-body').querySelector(`#edit_name_${that.locales[l]}`).value;

                      div.querySelector("div.trix-content").innerHTML = document.querySelector('.bootbox-body').querySelector(`#edit_description_${that.locales[l]}`).value;
                    });
                  }
                }
              }
            }
          }
        });

        new Sortable(box[0].querySelector("div.items"), {
            handle: '.handle',
            animation: 150
        });
      },
      error: function(data) {
      }
    });
  }

  shopDeleteItem() {
    let pos = event.target.dataset.index;
    let cards = this.webshop_tab_content_startpage_countriesTarget.querySelector(".tab-pane.active").querySelectorAll('.card');
    bootbox.confirm({
      message: I18n.t('webshop.confirm.remove_position'),
      buttons: {
        confirm: {
          label: I18n.t('btn.delete'),
          className: 'btn-danger'
        },
        cancel: {
          label: I18n.t('btn.cancel'),
          className: 'btn-outline-secondary'
        }
      },
      callback: function (result) {
        if(result) {
          cards[pos].remove();
        }
      }
    });
  }

  shopAppendSection() {
    let style = event.target.dataset.style;
    let cards = this.webshop_tab_content_startpage_countriesTarget.querySelector(".tab-pane.active").querySelectorAll('.card');
    let locale = this.locale;
    let locales = this.locales;
    let uuid = self.crypto.randomUUID();

    let card = document.createElement('div');
    let html = `
      <div class="card mb-3 rounded-1" data-style="${style}" data-uuid="" data-item="product" style="max-width:600px;">
        <input type="hidden" id="uuid" value="${uuid}">
        <input type="hidden" id="style" value="${style}">
        <input type="hidden" id="item" value="product">
        <input type="hidden" id="picture" value="">
        <input type="hidden" id="thumbnail" value="">

        <div class="d-flex justify-content-between align-items-center border-bottom mb-3">
          <div class="handle pointer-move-up-down p-2">
            <i class="fa-solid fa-grip-vertical fa-fw"></i>
          </div>
          <div class="ms-0 me-auto small semi-bold item">

          </div>
          <div class="mt-1">
            <button type="button" class="btn btn-xs btn-outline-secondary my-auto" data-action="click->settings#shopEditItem">
              <i class="fa-solid fa-pen"></i>
              ${I18n.t('btn.edit')}
            </button>
            <button type="button" class="btn btn-xs btn-danger my-auto me-1" data-action="click->settings#shopDeleteItem" data-index="${cards.length}">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="card-body pt-0">
    `
      switch(style) {
        case 'single-left':
          html += `
            <div class="d-flex justify-content-between small border-bottom mb-2">
              <div data-header="style">
                <i class="fa-solid fa-mattress-pillow fa-rotate-180"></i> ${I18n.t('webshop.sections.single_left')}
              </div>
              <div>
          `
          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="locales_${cards.length}" id="locale_${cards.length}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                <label class="form-check-label" for="locale_${cards.length}_${locales[l]}">
                  ${locales[l].toUpperCase()}
                </label>
              </div>
            `
          }
          html += `
              </div>
            </div>
            <div class="d-flex justify-content-between">
          `
          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="content smaller pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="">
                <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${cards.length}" value="-" readonly>
                <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                  -
                </div>
              </div>
            `
          }
          html += `
              <figure class="figure" style="max-height:200px;max-width:200px;">
                <img src="" class="figure-img img-fluid rounded-1">
              </figure>
            </div>
          `
          break;
        case 'single-right':
          html += `
            <div class="d-flex justify-content-between small border-bottom mb-2">
              <div data-header="style">
                <i class="fa-solid fa-mattress-pillow"></i> ${I18n.t('webshop.sections.single_right')}
              </div>
              <div>
          `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="locales_${cards.length}" id="locale_${cards.length}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                  <label class="form-check-label" for="locale_${cards.length}_${locales[l]}">
                    ${locales[l].toUpperCase()}
                  </label>
                </div>
              `
            }
            html += `
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <figure class="figure" style="max-height:200px;max-width:200px;">
                  <img src="" class="figure-img img-fluid rounded-1">
                </figure>
            `
            for(let l = 0; l < locales.length; l++) {
              html += `
                <div class="content smaller ps-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="">
                  <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${cards.length}" value="-" readonly>
                  <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                    &nbsp;
                  </div>
                </div>
              `
            }
          html += `
            </div>
          `
          break;
        case 'banner':
          html += `
            <div class="d-flex justify-content-between small border-bottom mb-2">
              <div data-header="style">
                <i class="fa-solid fa-image"></i>
                ${I18n.t('webshop.sections.banner')}
              </div>
              <div>
          `
          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="locales_${cards.length}" id="locale_${cards.length}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                <label class="form-check-label" for="locale_${cards.length}_${locales[l]}">
                  ${locales[l].toUpperCase()}
                </label>
              </div>
            `
          }
          html += `
              </div>
            </div>
            <figure class="figure w-100 me-2 text-center">
              <img src="" class="figure-img img-fluid rounded-1" style="max-height:250px;">
            </figure>
          `

          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="content smaller pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}" data-url="">
                <input type="text" class="form-control-plaintext form-control-sm border p-1" id="name_${cards.length}" value="-" readonly>
                <div class="trix-content border pointer-text rounded-1 p-1 mt-2">
                  -
                </div>
              </div>
              `
          }
          break;
        case 'gallery':
        case 'list':
          html += `
            <div class="d-flex justify-content-between small border-bottom mb-2">
              <div data-header="style">
                <i class="fa-solid fa-ellipsis"></i>
                ${I18n.t(`webshop.sections.${style}`)}
              </div>
            <div>
          `
          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="locales_${cards.length}" id="locale_${cards.length}_${locales[l]}" value="${locales[l]}" ${locales[l] == locale ? 'checked' : ''} data-locale="${locales[l]}" data-action="click->settings#shopToggleLocale">
                <label class="form-check-label" for="locale_${cards.length}_${locales[l]}">
                  ${locales[l].toUpperCase()}
                </label>
              </div>
            `
          }
          html += `
              </div>
            </div>
          `

          for(let l = 0; l < locales.length; l++) {
            html += `
              <div class="content smaller mb-2 pe-2 ${locales[l] == locale ? '' : 'd-none'}" data-locale="${locales[l]}">
                <input type="text" class="form-control-plaintext form-control-sm border p-1 ${style == 'gallery' ? "d-none" : ""}" id="header" readonly>
              </div>
              `
          }

          html += `
            <div class="d-flex justify-content-between items">
            </div>
          `
          break;
      }
    `
        </div>
      </div>
    `

    card.innerHTML = html;

    this.webshop_tab_content_startpage_countriesTarget.querySelector(".tab-pane.active").append(card);
  }

  shopSaveSections() {
    let sections = {}
    this.webshop_tab_content_startpage_countriesTarget.querySelectorAll("div.tab-pane").forEach((div, i) => {
      sections[div.dataset.country] = []

      let cards = div.querySelectorAll('.card');
      for(let i = 0; i < cards.length; i++) {
        let locales = cards[i].querySelectorAll('.content');

        let section = {}
        if(cards[i].querySelector('#style').value == 'list' || cards[i].querySelector('#style').value == 'gallery') {
          section = {
            "style": cards[i].querySelector('#style').value,
            "items": []
          }

          let locales = cards[i].querySelectorAll('.content');
          for(let ii = 0; ii < locales.length; ii++) {
            section[locales[ii].dataset.locale] = {
              "header": locales[ii].querySelector('input').value,
            }
          }

          let items = cards[i].querySelectorAll('.items > .item');
          for(let ii = 0; ii < items.length; ii++) {
            let section_item = {
              item: items[ii].querySelector('#item').value,
              picture: items[ii].querySelector('#picture').value,
              thumbnail: items[ii].querySelector('#thumbnail').value,
              uuid: items[ii].querySelector('#uuid').value
            }

            for(let l = 0; l < this.locales.length; l++) {
              section_item[this.locales[l]] = {
                name: items[ii].querySelector(`#name_${this.locales[l]}`).value,
                description: items[ii].querySelector(`#description_${this.locales[l]}`).value,
                url: ''
              }
            }

            section['items'].push(section_item)
          }
        } else {
          section = {
            "uuid": cards[i].querySelector('#uuid').value,
            "style": cards[i].querySelector('#style').value,
            "picture": cards[i].querySelector('#picture').value,
            "thumbnail": cards[i].querySelector('#thumbnail').value,
            "item": cards[i].querySelector('#item').value
          }
          let locales = cards[i].querySelectorAll('.content');
          for(let ii = 0; ii < locales.length; ii++) {
            section[locales[ii].dataset.locale] = {
              "name": locales[ii].querySelector('input').value,
              "description": locales[ii].querySelector('div.trix-content').innerHTML.trim(),
              "url": locales[ii].dataset.url,
            }
          }
        }
        sections[div.dataset.country].push(section)
      }
    });

    var fd = new FormData();
    fd.append("webshop[uuid]", this.uuid);
    fd.append("start[sections]", JSON.stringify(sections));

    Rails.ajax({
      url: `/${this.locale}/webshop/config`,
      type: "post",
      data: fd,
      success: function(data) {
      },
      error: function(data) {
        bootbox.alert(`${error}<br><br><b>${data}</b>`);
      }
    });
  }

  shopSelectItem() {
    let dialog = bootstrap.Modal.getOrCreateInstance(document.querySelector('#itemSelectDialog'));
    dialog.show();
  }

  shopSelectCategory() {
    let dialog = bootstrap.Modal.getOrCreateInstance(document.querySelector('#categorySelectDialog'));
    dialog.show();
  }

  shopCategorySelected() {
    let that = this;
    let uuid = event.target.parentNode.dataset.uuid;

    Rails.ajax({
      url: `/${this.locale}/item/category/${uuid}?descriptions=true`,
      type: "get",
      success: function(data) {
        let modal = document.querySelector(".bootbox-body");

        let style = modal.querySelector("input[name=style]:checked").value;
        if(style == "list" || style == "gallery") {
          let divItems = modal.querySelector(".items");
          let picture;
          let thumbnail;
          if(data.images.length > 0) {
            picture = data.images[0].picture;
            thumbnail = data.images[0].thumbnail;
          }
          let width = "160px";
          if(style == "gallery") {
            width = "24%"
          }

          let html = `
            <div class="item me-2" style="width:${width};">
              <input type="hidden" name="items[]" id="uuid" value="${data.uuid}">
              <input type="hidden" name="items[]" id="style" value="">
              <input type="hidden" name="items[]" id="item" value="category">
              <input type="hidden" name="items[]" id="picture" value="${picture}">
              <input type="hidden" name="items[]" id="thumbnail" value="${thumbnail}">

              <div class="position-absolute d-flex justify-content-between">
                <div class="handle pointer-grab p-1">
                  <i class="fa-solid fa-grip-vertical"></i>
                </div>
                <div>
                  <button type="button" class="btn btn-xs btn-danger" onclick="listDeleteItem()" tabindex=-1>
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>

              <figure class="figure me-2" style="max-height:90%;max-width:90%;">
                <img src="${thumbnail}" class="figure-img img-fluid rounded-1">
              </figure>

              <div class="nav nav-tabs" role="tablist">
              `

              for(let l = 0; l < that.locales.length; l++) {
              html += `
                  <button class="nav-item nav-link smaller ${l == 0 ? 'active' : ''}" type="button" data-bs-target="#item_${divItems.children.length}_${that.locales[l]}" role="tab" data-bs-toggle="tab" aria-selected="${l == 0 ? 'true' : ''}">
                  ${that.locales[l].toUpperCase()}
                  </button>
              `
              }

            html += `
              </div>
              <div class="tab-content mb-4">
            `
            for(let l = 0; l < that.locales.length; l++) {

              let name;
              let arr = data.i18n.filter(i18n => {
                return i18n.locale == that.locales[l];
              });
              if(arr.length > 0) {
                name = arr[0].name;
              }

              html += `
                <div role="tabpanel" class="tab-pane pt-2 ps-2 pe-2 ${l == 0 ? 'active show' : ''}" id="item_${divItems.children.length}_${that.locales[l]}">
                  <div class="input-group input-group-sm mb-3">
                    <span class="input-group-text" id="basic-addon1">${that.locales[l].toUpperCase()}</span>
                    <input type="text" class="form-control form-control-sm" name="items[]" id="name" data-locale="${that.locales[l]}" value="${name}">
                  </div>
                  <textarea class="form-control ${style == "gallery" ? '' : 'd-none'}" name="items[]" id="description" data-locale="${that.locales[l]}" rows="3"></textarea>
                </div>
              `
            }
          html += `
              </div>
            </div>
          `
          divItems.innerHTML += html;
        } else {
          let inp_i18n;
          let inp_uuid = modal.querySelector('input#uuid');
          let inp_name;
          let inp_item = modal.querySelector('input#item');
          let div_images = modal.querySelector('div.images');

          for(let l = 0; l < that.locales.length; l++) {
            inp_i18n = modal.querySelector(`div#section_${that.locales[l]} input.form-control-plaintext`);
            inp_name = modal.querySelector(`input#name_${that.locales[l]}`);
            let element = modal.querySelector(`div#section_${that.locales[l]} trix-editor`)
            if(inp_name) {
              let arr = data.i18n.filter(i18n => {
                return i18n.locale == that.locales[l];
              });
              if(arr.length > 0) {
                inp_i18n.value = arr[0].name;
                inp_name.value = arr[0].name;
                if(arr[0].description) {
                  element.editor.loadHTML(arr[0].description)
                }
              }
            }
          }

          inp_item.value = 'category';
          inp_uuid.value = data.uuid;

          div_images.innerHTML = '';
          for(let i = 0;i < data.images.length; i++) {
            div_images.innerHTML += `
              <div>
                <div class="form-check d-flex flex-column">
                  <input class="form-check-input ms-2 mb-1" type="radio" name="image" id="img${i}" data-uuid="" data-image="${data.images[i].picture}" data-thumbnail="${data.images[i].thumbnail}" ${i == 0 ? 'checked' : ''}>
                  <label class="form-check-label" for="img${i}">
                    <img src="${data.images[i].thumbnail}" class="img-thumbnail m-1" style="max-width:150px;max-height:150px;">
                  </label>
                </div>
              </div>
            `
          }
        }

        that.categorySelectDialog.hide();
      },
      error: function(data) {}
    })
  }

  populateCategoryPresentation(data) {
    const panel = this.element.querySelector('#category-presentation');
    if (!panel) return;
    const stored = data.config.find(entry => entry.attr === 'categories.presentation')?.value || {};
    panel.querySelectorAll('[data-category-option]').forEach(input => {
      const key = input.dataset.categoryOption;
      if (input.type === 'checkbox') {
        if (input.dataset.categoryValue) {
          const defaults = key === 'filter_fields' ? ['price','brand','size','color','slip_resistance','surface','height'] : ['price_asc','price_desc','discount_desc'];
          input.checked = (stored[key] || defaults).includes(input.dataset.categoryValue);
        } else {
          const defaults = {show_count: true, sorting_enabled: false, filters_enabled: data.system.items?.show_filters === true, group_variants: true, catalogue_enabled: false, catalogue_all_products: true};
          input.checked = stored[key] ?? (key === 'catalogue_navigation_enabled' ? stored.catalogue_enabled === true : defaults[key]);
        }
      } else {
        const defaults = {mode: 'legacy', default_sort: 'standard', navigation_label: '', columns: 3, batch_size: 50, tree_expansion: 'active', catalogue_category: ''};
        input.value = stored[key] ?? defaults[key];
      }
    });
    panel.querySelectorAll('[data-category-filter-position]').forEach(input => {
      const mode = input.dataset.categoryFilterPosition;
      input.value = stored.filter_positions?.[mode] ?? (mode === 'expanded' ? 'top' : 'left');
    });
    const translations = panel.querySelector('[data-category-translations]');
    const defaultLabels = JSON.parse(panel.dataset.categoryDefaultLabels);
    translations.replaceChildren();
    const locales = data.system.locales || [data.system.locale];
    const activeLocale = locales.includes(this.locale) ? this.locale : (locales.includes(data.system.locale) ? data.system.locale : locales[0]);
    const tabs = document.createElement('div');
    tabs.className = 'nav nav-tabs mb-3';
    tabs.setAttribute('role', 'tablist');
    const content = document.createElement('div');
    content.className = 'tab-content';
    translations.append(tabs, content);
    locales.forEach(locale => {
      const active = locale === activeLocale;
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.id = `category-language-tab-${locale}`;
      tab.className = `nav-link${active ? ' active' : ''}`;
      tab.dataset.bsToggle = 'tab';
      tab.dataset.bsTarget = `#category-language-pane-${locale}`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', `category-language-pane-${locale}`);
      tab.setAttribute('aria-selected', String(active));
      tab.textContent = I18n.t(`language.${locale}`);
      const pane = document.createElement('div');
      pane.id = `category-language-pane-${locale}`;
      pane.className = `tab-pane fade${active ? ' show active' : ''}`;
      pane.setAttribute('role', 'tabpanel');
      pane.setAttribute('aria-labelledby', tab.id);
      const label = document.createElement('label');
      label.className = 'visually-hidden';
      label.htmlFor = `category-navigation-label-${locale}`;
      label.textContent = I18n.t(`language.${locale}`);
      const input = document.createElement('input');
      input.id = label.htmlFor;
      input.className = 'form-control';
      input.maxLength = 100;
      input.dataset.categoryLocale = locale;
      input.value = stored.navigation_labels?.[locale] ?? (locale === data.system.locale ? stored.navigation_label || '' : '');
      input.placeholder = defaultLabels[locale] || I18n.t('category_controls.catalogue');
      pane.append(label, input);
      tabs.append(tab);
      content.append(pane);
    });
    this.updateCatalogueControls();
    panel.querySelector('fieldset').disabled = false;
    panel.querySelector('[role=status]').textContent = '';
  }

  updateCatalogueControls() {
    const panel = this.element.querySelector('#category-presentation');
    const category = panel.querySelector('[data-category-option="catalogue_category"]').value;
    const edit = panel.querySelector('[data-catalogue-edit]');
    if (edit) {
      edit.classList.toggle('d-none', !category);
      if (category) edit.href = edit.dataset.categoryUrl.replace('CATALOGUE_UUID', encodeURIComponent(category));
    }
    const linked = panel.querySelector('[data-category-option="catalogue_enabled"]').checked;
    panel.querySelector('[data-category-option="catalogue_navigation_enabled"]').disabled = !linked;
    panel.querySelector('[data-category-translations]').closest('.col-12').classList.toggle('d-none', linked);
  }

  saveCategoryPresentation() {
    const panel = this.element.querySelector('#category-presentation');
    const value = {filter_fields: [], sort_options: [], navigation_labels: {}, filter_positions: {}};
    panel.querySelectorAll('[data-category-option]').forEach(input => {
      const key = input.dataset.categoryOption;
      if (input.dataset.categoryValue) { if (input.checked) value[key].push(input.dataset.categoryValue); }
      else if (input.type === 'checkbox') value[key] = input.checked;
      else if (['columns', 'batch_size'].includes(key)) value[key] = Number(input.value);
      else value[key] = key === 'navigation_label' ? input.value.trim() : input.value;
    });
    panel.querySelectorAll('[data-category-locale]').forEach(input => { value.navigation_labels[input.dataset.categoryLocale] = input.value.trim(); });
    panel.querySelectorAll('[data-category-filter-position]').forEach(input => { value.filter_positions[input.dataset.categoryFilterPosition] = input.value; });
    if (value.catalogue_enabled && !value.catalogue_category) {
      panel.querySelector('[role=status]').textContent = I18n.t('category_controls.catalogue_choose');
      panel.querySelector('[data-category-option="catalogue_category"]').focus();
      return;
    }
    if (!value.sort_options.includes(value.default_sort)) value.default_sort = 'standard';
    const fd = new FormData();
    fd.append('webshop[uuid]', this.uuid);
    fd.append('webshop[category_configuration]', '1');
    fd.append('category_presentation', JSON.stringify(value));
    const button = panel.querySelector('[data-category-save]');
    const status = panel.querySelector('[role=status]');
    button.disabled = true;
    status.textContent = '';
    const failed = () => { status.textContent = I18n.t('category_controls.save_error'); button.disabled = false; };
    Rails.ajax({url: `/${this.locale}/webshop/${this.uuid}/config?csrf_only=1`, type: 'get',
      success: data => {
        if (typeof data.csrf_token !== 'string' || !data.csrf_token) { failed(); return; }
        fd.append('authenticity_token', data.csrf_token);
        Rails.ajax({url: '/' + this.locale + '/webshop/config', type: 'post', data: fd,
          success: () => { panel.querySelector('[data-category-option="default_sort"]').value = value.default_sort; status.textContent = I18n.t('category_controls.saved'); button.disabled = false; },
          error: failed
        });
      },
      error: failed
    });
  }

  shopSaveCatgoriesOrders() {
    let json = []
    let cards = this.webshop_categoriesTarget.querySelectorAll(".card");
    for(let i = 0; i < cards.length; i++) {
      let j = {
        uuid: cards[i].dataset.uuid,
        categories: []
      }
      let li = cards[i].querySelectorAll('li');
      for(let ii = 0; ii < li.length; ii++) {
        j.categories.push(li[ii].dataset.uuid);
      }
      json.push(j)
    }

    var fd = new FormData();
    fd.append("webshop[uuid]", this.uuid);
    fd.append("categories", JSON.stringify(json));

    Rails.ajax({
      url: `/${this.locale}/webshop/config`,
      type: "post",
      data: fd,
      success: function(data) {
      },
      error: function(data) {
        bootbox.alert(`${error}<br><br><b>${data}</b>`);
      }
    });
  }

  shopInitCategorySelectDialog() {
    this.categorySelectDialog = new bootstrap.Modal(document.querySelector('#categorySelectDialog'), {
      keyboard: true,
      focus: true
    });
  }

  shopCategoryItems() {
    let that = this;
    var $table;
    let category = event.target.dataset.uuid;

    Rails.ajax({
      url: `/${this.locale}/webshop/${this.uuid}/category/${category}/items`,
      type: "get",
      success: function(data) {
        let html = `
        <input type="hidden" id="items">
        <table class="table table-sm table-striped mb-4" data-height="${window.innerHeight-300}">
          <thead>
            <tr class="small">
              <th data-field="uuid" class="d-none">UUID</th>
              <th data-field="i18n_name" data-sortable="true">${I18n.t('item.name')}</th>
              <th data-field="number" data-sortable="true">${I18n.t('item.number')}</th>
              <th data-field="ean" data-sortable="true">${I18n.t('item.ean')}</th>
              <th data-field="color" data-sortable="true">${I18n.t('item.color')}</th>
              <th data-field="size" data-sortable="true">${I18n.t('item.size')}</th>
            </tr>
          </thead>
          <tbody class="smaller pointer-grab">
          </tbody>
          </table>
        `

        var box = bootbox.dialog({
          title: I18n.t('item.items'),
          message: html,
          onEscape: true,
          size: 'xl',
          buttons: {
            cancel: {
              label: I18n.t('btn.cancel'),
              className: "btn-outline-secondary",
            },
            delete: {
              label: I18n.t('btn.apply'),
              className: "btn-success",
              callback: function() {
                var fd = new FormData();
                fd.append("webshop", that.uuid);
                fd.append("category", category);
                fd.append("items", box[0].querySelector('input').value);

                Rails.ajax({
                  url: `/${this.locale}/webshop/category/items`,
                  type: "post",
                  data: fd,
                  success: function(data) {
                  },
                  error: function(data) {}
                });
              }
            }
          }
        });

        $table = $(box[0].querySelector('table')).bootstrapTable({data: data});
        let uuids = []
        for (var i = 0, row; row = $table[0].rows[i]; i++) {
          if(i>0) {
            uuids.push(row.cells[0].textContent)
          }
        }
        box[0].querySelector('input').value = JSON.stringify(uuids)

        new Sortable(box[0].querySelector('table > tbody'), {
          animation: 150,
          onSort: function (/**Event*/evt) {
            let uuids = []
            for (var i = 0, row; row = $table[0].rows[i]; i++) {
              if(i>0) {
                uuids.push(row.cells[0].textContent)
              }
            }
            box[0].querySelector('input').value = JSON.stringify(uuids)
        	},
        });
        box[0].querySelector(".bootbox-body").style.paddingBottom = "20px";

      },
      error: function(data) {}
    });
  }

  shopInitItemSelectDialog() {
    let that = this;

    this.itemSelectDialog = new bootstrap.Modal(document.querySelector('#itemSelectDialog'), {
      keyboard: true,
      focus: true
    });

    let table = $('#itemSelect').bootstrapTable({
      locale: this.locale,
      url: `/${this.locale}/orders/items`,
      search: true,
      loadingFontSize: '1rem',
      classes: 'table',
      searchTimeOut: 500,
      onClickRow: (row, $element, field) => {
        Rails.ajax({
          url: `/${this.locale}/item/${row.uuid}.json?images=true&descriptions=true`,
          type: "get",
          success: function(data) {

            window.switchImage = function() {
              let div = event.target.closest('div.item');
              div.querySelector("input#picture").value = event.target.dataset.picture;
              div.querySelector("input#thumbnail").value = event.target.src;
              div.querySelector("figure > img").src = event.target.src;

              bootstrap.Popover.getOrCreateInstance(div.querySelector('[data-bs-toggle="popover"]')).hide();
            }

            let modal = document.querySelector(".bootbox-body");

            let style = modal.querySelector("input[name=style]:checked").value;
            if(style == "list" || style == "gallery") {

              let divItems = modal.querySelector(".items");

              if(style == 'gallery') {
                if(divItems.children.length >= 4) {
                  return;
                }
              }
              let picture;
              let thumbnail;
              let popover = "";
              if(data.images.length > 0) {
                picture = data.images[0].image;
                thumbnail = data.images[0].thumbnail;

                for(let i = 0; i < data.images.length; i++) {
                  popover += `<img src='${data.images[i].thumbnail}' data-picture='${data.images[i].image}' class='img-thumbnail pointer-hand m-2' onclick='switchImage()'>`
                }
              }

              let width = "160px;"
              if(style == "gallery") {
                width = "24%;"
              }

              let html = `
                <div class="item me-2" style="width:${width};">
                  <input type="hidden" name="items[]" id="uuid" value="${data.uuid}">
                  <input type="hidden" name="items[]" id="style" value="">
                  <input type="hidden" name="items[]" id="item" value="product">
                  <input type="hidden" name="items[]" id="picture" value="${picture}">
                  <input type="hidden" name="items[]" id="thumbnail" value="${thumbnail}">

                  <div class="position-absolute d-flex justify-content-between">
                    <div class="handle pointer-grab p-1">
                      <i class="fa-solid fa-grip-vertical"></i>
                    </div>
                    <div>
                      <button type="button" class="btn btn-xs btn-outline-secondary" tabindex=-1 data-bs-toggle="popover" data-bs-placement="top" data-bs-html="true" data-bs-content="${popover}">
                        <i class="fa-solid fa-images fa-fw"></i>
                      </button>
                      <br>
                      <button type="button" class="btn btn-xs btn-danger" onclick="listDeleteItem()" tabindex=-1>
                        <i class="fa-solid fa-trash fa-fw"></i>
                      </button>
                    </div>
                  </div>

                  <figure class="figure me-2" style="max-height:90%;max-width:90%;">
                    <img src="${thumbnail}" class="figure-img img-fluid rounded-1">
                  </figure>

                  <div class="nav nav-tabs" role="tablist">
                  `
                  for(let l = 0; l < that.locales.length; l++) {
                    html += `
                      <button class="nav-item nav-link smaller ${l == 0 ? 'active' : ''}" type="button" data-bs-target="#item_${divItems.children.length}_${that.locales[l]}" role="tab" data-bs-toggle="tab" aria-selected="${l == 0 ? 'true' : ''}">
                        ${that.locales[l].toUpperCase()}
                      </button>
                    `
                  }

                  html += `
                    </div>
                    <div class="tab-content mb-4">
                  `
                for(let l = 0; l < that.locales.length; l++) {

                  let name;
                  let arr = data.i18n.filter(i18n => {
                    return i18n.locale == that.locales[l];
                  });
                  if(arr.length > 0) {
                    name = arr[0].name;
                  }

                  html += `
                    <div role="tabpanel" class="tab-pane pt-2 ps-2 pe-2 ${l == 0 ? 'active show' : ''}" id="item_${divItems.children.length}_${that.locales[l]}">
                      <div class="input-group input-group-sm mb-3">
                        <span class="input-group-text" id="basic-addon1">${that.locales[l].toUpperCase()}</span>
                        <input type="text" class="form-control form-control-sm" name="items[]" id="name" data-locale="${that.locales[l]}" value="${name}">
                      </div>
                      <textarea class="form-control ${style == "gallery" ? '' : 'd-none'}" name="items[]" id="description" data-locale="${that.locales[l]}" rows="3"></textarea>
                    </div>
                  `
                }
              html += `
                  </div>
                </div>
              `
              divItems.innerHTML += html;
              setTimeout(() => {
                const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
                const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {container: popoverTriggerEl.closest('div.item'), sanitize: false}))

                if(style == 'gallery') {
                  if(divItems.children.length == 4) {
                    modal.querySelectorAll('button.btn-xs.add').forEach((btn, i) => {
                      btn.setAttribute("disabled", "true")
                    });
                  }
                }
              }, 250);
            } else {
              let inp_uuid = modal.querySelector('input#uuid');
              let inp_i18n;
              let inp_name;
              let inp_item = modal.querySelector('input#item');
              let div_images = modal.querySelector('div.images');

              for(let l = 0; l < that.locales.length; l++) {
                inp_i18n = modal.querySelector(`div#section_${that.locales[l]} input.form-control-plaintext`);
                inp_name = modal.querySelector(`input#name_${that.locales[l]}`);
                let element = modal.querySelector(`div#section_${that.locales[l]} trix-editor`)
                if(inp_name) {
                  let arr = data.i18n.filter(i18n => {
                    return i18n.locale == that.locales[l];
                  });
                  if(arr.length > 0) {
                    inp_i18n.value = arr[0].name;
                    inp_name.value = arr[0].name;
                    element.editor.loadHTML(arr[0].description_short.body)
                  }
                }
              }

              inp_item.value = 'product';
              inp_uuid.value = data.uuid;

              div_images.innerHTML = '';
              for(let i = 0;i < data.images.length; i++) {
                div_images.innerHTML += `
                  <div>
                    <div class="form-check d-flex flex-column">
                      <input class="form-check-input ms-2 mb-1" type="radio" name="image" id="img${i}" data-uuid="${data.images[i].uuid}" data-image="${data.images[i].image}" data-thumbnail="${data.images[i].thumbnail}" ${i == 0 ? 'checked' : ''}>
                      <label class="form-check-label" for="img${i}">
                        <img src="${data.images[i].thumbnail}" class="img-thumbnail m-1" style="max-width:150px;max-height:150px;">
                      </label>
                    </div>
                  </div>
                `
              }
            }
          },
          error: function(data) {

          }
        });

        that.itemSelectDialog.hide();
      }
    });

    document.querySelector('#itemSelectDialog div.search').classList.add('w-75');
    document.querySelector('#itemSelectDialog input.search-input').style.height = '34px';

    that.vat_select = '';
    Rails.ajax({
      url: `/${that.locale}/orders/vats`,
      type: "get",
      data: "",
      success: function(data) {
        that.vat = data;
      },
      error: function(data) {
      }
    });

    that.warehouse_select = '';
    Rails.ajax({
      url: `/${that.locale}/warehouses`,
      type: "get",
      data: "",
      success: function(data) {
        that.warehouses = data;
        data.forEach((warehouse, i) => {
          that.warehouse_select += `<option value="${warehouse.uuid}" style="color: ${warehouse.data.color}">${warehouse.name}</option>`
        });
      },
      error: function(data) {
      }
    });

    window.itemNameFormatter = function(name, item) {
      return `${name}&nbsp;&nbsp;<span class="small text-muted">${[item.size, item.color].filter(item => item).join(' | ')}</span>`
    }

    window.itemStockFormatter = function(stock, item) {
      if(stock == null) {
        stock = '-'
      }
      if(item.with_stock) {
        return `
          <button type="button" class="btn btn-outline-light btn-sm text-dark" data-action="click->items#loadStockQuantities" data-uuid="${item.uuid}" data-loaded="false">
            ${stock}
          </button>
          <table class="small table-borderless table-sm warehouse-quantities"></table>
        `
      } else {
        return ''
      }
    }

    window.itemStatusFormatter = function(status, item) {
      let str = '<span class="badge bg-secondary">';
      if(item.statusname) {
        if(item.status_subscription_id) {
          str += item.statusname;
        } else {
          str += I18n.t(`item.states.${item.statusname}`);
        }
      }
      str += '</span>';
      return str
    }

    window.itemPriceFormatter = function(price, item) {
      if(price && !isNaN(price)) {
        if(item.price_with_discount) {
          return `
            <span class="text-danger">${item.price_with_discount.toFixed(2)} ${I18n.t(`currencies.abbr.${item.currency}`)}</span>
            <br>
            <small class="text-muted">
              ${item.price_with_vat.toFixed(2)} ${I18n.t(`currencies.abbr.${item.currency}`)}
            </small>
          `
        } else {
          return `
            ${price.toFixed(2)} ${I18n.t(`currencies.abbr.${item.currency}`)}
            <br>
            <small class="text-muted">
              ${item.price_with_vat.toFixed(2)} ${I18n.t(`currencies.abbr.${item.currency}`)}
            </small>
          `
        }
      } else {
        return ''
      }
    }

    window.itemReservedFormatter = function(reserved, item) {
      if(item.with_stock && item.reserved && item.reserved > 0) {
        return reserved
      } else {
        return ''
      }
    }

    window.itemAvailabilityFormatter = function(available, item) {
      if(item.with_stock) {
        return item.availability
      } else {
        return ''
      }
    }
  }

  setupBlogTrixUploadHandler() {
    const that = this;
    let blogUploadHandlerInstalled = false;

    // Function to check if we're in a blog context
    const isBlogContext = (element) => {
      const owner = element.closest('[data-blog-webshop]');
      if (!owner || owner.dataset.blogWebshop !== that.uuid || !that.element.isConnected) return false;
      // Check if the trix editor is inside a blog dialog or has blog-related content
      const bootboxBody = element.closest('.bootbox-body');
      if (bootboxBody) {
        // Check if the dialog title contains "Blog" or if we're in blog editing context
        const dialog = bootboxBody.closest('.bootbox');
        const title = dialog?.querySelector('.bootbox-header .modal-title, .modal-title');
        if (title && title.textContent.toLowerCase().includes('blog')) {
          return true;
        }

        // Also check for blog-specific input elements or labels
        const blogElements = bootboxBody.querySelectorAll('input[id*="title_"], label[for="title"]');
        if (blogElements.length > 0) {
          // Check if there's "Blog" text in the labels
          for (let el of blogElements) {
            if (el.textContent && el.textContent.toLowerCase().includes('blog')) {
              return true;
            }
          }
        }

        // Check if the bootbox body contains accordion with blog content
        const accordion = bootboxBody.querySelector('#pagesContent');
        if (accordion) {
          return true; // This appears to be the blog/pages dialog
        }
      }

      return false;
    };

    // Custom DirectUpload class for blogs only
    const BlogDirectUpload = class {
      constructor(file, url, delegate) {
        this.file = file;
        this.delegate = delegate;
        this.uploadFile();
      }

      uploadFile() {
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('webshop', that.uuid);
        formData.append('webshop', that.uuid);

        fetch(`/${that.locale}/blog/upload`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.delegate.directUploadDidComplete({
              key: data.key,
              fileName: data.filename,
              contentType: data.content_type,
              byteSize: data.byte_size,
              signed_id: data.signed_id,
              service_url: data.direct_url
            });
          } else {
            this.delegate.directUploadDidError(new Error(data.error));
          }
        })
        .catch(error => {
          this.delegate.directUploadDidError(error);
        });
      }
    };

    // Store original DirectUpload
    const OriginalDirectUpload = window.DirectUpload;

    // Override DirectUpload only for blog contexts
    document.addEventListener('trix-before-initialize', function(event) {
      const trixElement = event.target;
      if (isBlogContext(trixElement)) {
        // Temporarily override DirectUpload for this blog editor
        window.DirectUpload = BlogDirectUpload;
        blogUploadHandlerInstalled = true;
      }
    });

    // Handle trix-attachment-add for blog contexts only
    document.addEventListener('trix-attachment-add', function(event) {
      const attachment = event.attachment;
      const trixElement = event.target;

      if (attachment.file && !attachment.getURL() && isBlogContext(trixElement)) {
        const formData = new FormData();
        formData.append('file', attachment.file);
        formData.append('webshop', that.uuid);
        formData.append('webshop', that.uuid);

        fetch(`/${that.locale}/blog/upload`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            attachment.setAttributes({
              url: data.direct_url,
              href: data.direct_url
            });
          } else {
            attachment.remove();
            console.error('Upload failed:', data.error);
          }
        })
        .catch(error => {
          attachment.remove();
          console.error('Upload error:', error);
        });
      }
    });

    // Restore original DirectUpload when not in blog context
    document.addEventListener('trix-initialize', function(event) {
      const trixElement = event.target;
      if (!isBlogContext(trixElement) && blogUploadHandlerInstalled) {
        window.DirectUpload = OriginalDirectUpload;
        blogUploadHandlerInstalled = false;
      }
    });
  }
}

Object.assign(SettingsController.prototype, startpageSettings, cartSettings);
export default SettingsController;
